import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2b62405a = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _2b8b4159 = () => interopDefault(import('../pages/im.vue' /* webpackChunkName: "pages/im" */))
const _12349eb8 = () => interopDefault(import('../pages/Login.vue' /* webpackChunkName: "pages/Login" */))
const _3fe5cb3e = () => interopDefault(import('../pages/not-permission.vue' /* webpackChunkName: "pages/not-permission" */))
const _946824a6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _85d7de6a = () => interopDefault(import('../pages/index/account.vue' /* webpackChunkName: "pages/index/account" */))
const _fcd86002 = () => interopDefault(import('../pages/index/accountRecord/index.vue' /* webpackChunkName: "pages/index/accountRecord/index" */))
const _27ce2058 = () => interopDefault(import('../pages/index/approval/index.vue' /* webpackChunkName: "pages/index/approval/index" */))
const _20c1c14a = () => interopDefault(import('../pages/index/certificateManagement/index.vue' /* webpackChunkName: "pages/index/certificateManagement/index" */))
const _e717a444 = () => interopDefault(import('../pages/index/certificatePersonnel/index.vue' /* webpackChunkName: "pages/index/certificatePersonnel/index" */))
const _c0104f2a = () => interopDefault(import('../pages/index/dictionary/index.vue' /* webpackChunkName: "pages/index/dictionary/index" */))
const _505ce834 = () => interopDefault(import('../pages/index/educational/index.vue' /* webpackChunkName: "pages/index/educational/index" */))
const _1b5e22d8 = () => interopDefault(import('../pages/index/enrolmentChannel/index.vue' /* webpackChunkName: "pages/index/enrolmentChannel/index" */))
const _5d927b1a = () => interopDefault(import('../pages/index/feedback/index.vue' /* webpackChunkName: "pages/index/feedback/index" */))
const _a0da26a4 = () => interopDefault(import('../pages/index/groupqrcode/index.vue' /* webpackChunkName: "pages/index/groupqrcode/index" */))
const _27397f9b = () => interopDefault(import('../pages/index/hmtservice/index.vue' /* webpackChunkName: "pages/index/hmtservice/index" */))
const _e76e9e1a = () => interopDefault(import('../pages/index/index/index.vue' /* webpackChunkName: "pages/index/index/index" */))
const _7a0762da = () => interopDefault(import('../pages/index/manageDeposit/index.vue' /* webpackChunkName: "pages/index/manageDeposit/index" */))
const _005dc62c = () => interopDefault(import('../pages/index/manageDepositReturn/index.vue' /* webpackChunkName: "pages/index/manageDepositReturn/index" */))
const _1ef75594 = () => interopDefault(import('../pages/index/manageDepositX/index.vue' /* webpackChunkName: "pages/index/manageDepositX/index" */))
const _4f92c088 = () => interopDefault(import('../pages/index/manageMargin/index.vue' /* webpackChunkName: "pages/index/manageMargin/index" */))
const _4dc1ffd0 = () => interopDefault(import('../pages/index/manageMarginReturn/index.vue' /* webpackChunkName: "pages/index/manageMarginReturn/index" */))
const _0a50a4b4 = () => interopDefault(import('../pages/index/manageMarginX/index.vue' /* webpackChunkName: "pages/index/manageMarginX/index" */))
const _47d7bb9e = () => interopDefault(import('../pages/index/manageService/index.vue' /* webpackChunkName: "pages/index/manageService/index" */))
const _22f297de = () => interopDefault(import('../pages/index/manualReconciliation/index.vue' /* webpackChunkName: "pages/index/manualReconciliation/index" */))
const _46f07da6 = () => interopDefault(import('../pages/index/notice/index.vue' /* webpackChunkName: "pages/index/notice/index" */))
const _1ed5da60 = () => interopDefault(import('../pages/index/noticeOnline/index.vue' /* webpackChunkName: "pages/index/noticeOnline/index" */))
const _27e0c2f6 = () => interopDefault(import('../pages/index/policyForH5/index.vue' /* webpackChunkName: "pages/index/policyForH5/index" */))
const _26c4cb50 = () => interopDefault(import('../pages/index/product/index.vue' /* webpackChunkName: "pages/index/product/index" */))
const _d2d4a702 = () => interopDefault(import('../pages/index/reconcilation/index.vue' /* webpackChunkName: "pages/index/reconcilation/index" */))
const _0498c4aa = () => interopDefault(import('../pages/index/selfService/index.vue' /* webpackChunkName: "pages/index/selfService/index" */))
const _cd1c3258 = () => interopDefault(import('../pages/index/workflow/index.vue' /* webpackChunkName: "pages/index/workflow/index" */))
const _f6e79484 = () => interopDefault(import('../pages/index/aiReporting/aiOrder/index.vue' /* webpackChunkName: "pages/index/aiReporting/aiOrder/index" */))
const _2d1ddc6d = () => interopDefault(import('../pages/index/aiReporting/appletProduct/index.vue' /* webpackChunkName: "pages/index/aiReporting/appletProduct/index" */))
const _786b7208 = () => interopDefault(import('../pages/index/aiReporting/appletProductShare/index.vue' /* webpackChunkName: "pages/index/aiReporting/appletProductShare/index" */))
const _308c8eca = () => interopDefault(import('../pages/index/aiReporting/baseDataManager/index.vue' /* webpackChunkName: "pages/index/aiReporting/baseDataManager/index" */))
const _b65aa3bc = () => interopDefault(import('../pages/index/aiReporting/creditCards/index.vue' /* webpackChunkName: "pages/index/aiReporting/creditCards/index" */))
const _78cb3566 = () => interopDefault(import('../pages/index/aiReporting/feedbackStatistics/index.vue' /* webpackChunkName: "pages/index/aiReporting/feedbackStatistics/index" */))
const _157aafe8 = () => interopDefault(import('../pages/index/aiReporting/gptfeedback/index.vue' /* webpackChunkName: "pages/index/aiReporting/gptfeedback/index" */))
const _5438cfa5 = () => interopDefault(import('../pages/index/aiReporting/headQuarters/index.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/index" */))
const _188cc410 = () => interopDefault(import('../pages/index/aiReporting/policy/index.vue' /* webpackChunkName: "pages/index/aiReporting/policy/index" */))
const _1ba74f78 = () => interopDefault(import('../pages/index/aiReporting/policyInterpretation/index.vue' /* webpackChunkName: "pages/index/aiReporting/policyInterpretation/index" */))
const _310d7b16 = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/index.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/index" */))
const _1c1b372c = () => interopDefault(import('../pages/index/aiReporting/timeAxis/index.vue' /* webpackChunkName: "pages/index/aiReporting/timeAxis/index" */))
const _073a3789 = () => interopDefault(import('../pages/index/artExamination/academic/index.vue' /* webpackChunkName: "pages/index/artExamination/academic/index" */))
const _6dddc492 = () => interopDefault(import('../pages/index/artExamination/checkAndUpload/index.vue' /* webpackChunkName: "pages/index/artExamination/checkAndUpload/index" */))
const _e883d322 = () => interopDefault(import('../pages/index/artExamination/onePointOneLevelArt/index.vue' /* webpackChunkName: "pages/index/artExamination/onePointOneLevelArt/index" */))
const _6c3a03b4 = () => interopDefault(import('../pages/index/artExamination/policy/index.vue' /* webpackChunkName: "pages/index/artExamination/policy/index" */))
const _ceda3594 = () => interopDefault(import('../pages/index/artExamination/specialtyScore/index.vue' /* webpackChunkName: "pages/index/artExamination/specialtyScore/index" */))
const _173bfa90 = () => interopDefault(import('../pages/index/artExamination/university/index.vue' /* webpackChunkName: "pages/index/artExamination/university/index" */))
const _417a2802 = () => interopDefault(import('../pages/index/company/course/index.vue' /* webpackChunkName: "pages/index/company/course/index" */))
const _2d3666a9 = () => interopDefault(import('../pages/index/company/courseclassif/index.vue' /* webpackChunkName: "pages/index/company/courseclassif/index" */))
const _8c3012c0 = () => interopDefault(import('../pages/index/company/courselearning/index.vue' /* webpackChunkName: "pages/index/company/courselearning/index" */))
const _6ef4a826 = () => interopDefault(import('../pages/index/company/CourseLearningProgress/index.vue' /* webpackChunkName: "pages/index/company/CourseLearningProgress/index" */))
const _ccb3f828 = () => interopDefault(import('../pages/index/company/feedback/index.vue' /* webpackChunkName: "pages/index/company/feedback/index" */))
const _e46dcfc2 = () => interopDefault(import('../pages/index/company/studyNotes/index.vue' /* webpackChunkName: "pages/index/company/studyNotes/index" */))
const _299a0b76 = () => interopDefault(import('../pages/index/comprehensive/application/index.vue' /* webpackChunkName: "pages/index/comprehensive/application/index" */))
const _0cba60a3 = () => interopDefault(import('../pages/index/comprehensive/coverLetter/index.vue' /* webpackChunkName: "pages/index/comprehensive/coverLetter/index" */))
const _317eb88a = () => interopDefault(import('../pages/index/comprehensive/matchIntroduce/index.vue' /* webpackChunkName: "pages/index/comprehensive/matchIntroduce/index" */))
const _1dc99868 = () => interopDefault(import('../pages/index/comprehensive/qualitySpecialityInfo/index.vue' /* webpackChunkName: "pages/index/comprehensive/qualitySpecialityInfo/index" */))
const _72b06e7a = () => interopDefault(import('../pages/index/comprehensive/universityManage/index.vue' /* webpackChunkName: "pages/index/comprehensive/universityManage/index" */))
const _7e1e6a44 = () => interopDefault(import('../pages/index/comprehensive/videoManagement/index.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/index" */))
const _4176b470 = () => interopDefault(import('../pages/index/customer/assignStudent/index.vue' /* webpackChunkName: "pages/index/customer/assignStudent/index" */))
const _aba4ec60 = () => interopDefault(import('../pages/index/customer/customer/index.vue' /* webpackChunkName: "pages/index/customer/customer/index" */))
const _220099ce = () => interopDefault(import('../pages/index/customer/livingCustomer/index.vue' /* webpackChunkName: "pages/index/customer/livingCustomer/index" */))
const _38c6545f = () => interopDefault(import('../pages/index/customer/student/index.vue' /* webpackChunkName: "pages/index/customer/student/index" */))
const _5376b49d = () => interopDefault(import('../pages/index/customer/zonghe/index.vue' /* webpackChunkName: "pages/index/customer/zonghe/index" */))
const _d84c680a = () => interopDefault(import('../pages/index/customerStatistics/customerInfo/index.vue' /* webpackChunkName: "pages/index/customerStatistics/customerInfo/index" */))
const _696e97b2 = () => interopDefault(import('../pages/index/customerStatistics/statistics/index.vue' /* webpackChunkName: "pages/index/customerStatistics/statistics/index" */))
const _68628588 = () => interopDefault(import('../pages/index/dailyWeekly/weekly.vue' /* webpackChunkName: "pages/index/dailyWeekly/weekly" */))
const _60d855b7 = () => interopDefault(import('../pages/index/dailyWork/dailySpeech/index.vue' /* webpackChunkName: "pages/index/dailyWork/dailySpeech/index" */))
const _2a1654f3 = () => interopDefault(import('../pages/index/dailyWork/importWeek/index.vue' /* webpackChunkName: "pages/index/dailyWork/importWeek/index" */))
const _1d654d1a = () => interopDefault(import('../pages/index/dailyWork/monthList/index.vue' /* webpackChunkName: "pages/index/dailyWork/monthList/index" */))
const _3f170a28 = () => interopDefault(import('../pages/index/dailyWork/weekList/index.vue' /* webpackChunkName: "pages/index/dailyWork/weekList/index" */))
const _ea1a3b70 = () => interopDefault(import('../pages/index/dailyWork/weekTemplate/index.vue' /* webpackChunkName: "pages/index/dailyWork/weekTemplate/index" */))
const _5850af75 = () => interopDefault(import('../pages/index/dailyWork/yearList/index.vue' /* webpackChunkName: "pages/index/dailyWork/yearList/index" */))
const _24aa098f = () => interopDefault(import('../pages/index/examination/analysis/index.vue' /* webpackChunkName: "pages/index/examination/analysis/index" */))
const _c5ff9e22 = () => interopDefault(import('../pages/index/examination/bank/index.vue' /* webpackChunkName: "pages/index/examination/bank/index" */))
const _76232312 = () => interopDefault(import('../pages/index/examination/exam/index.vue' /* webpackChunkName: "pages/index/examination/exam/index" */))
const _05456868 = () => interopDefault(import('../pages/index/examination/myPlan/index.vue' /* webpackChunkName: "pages/index/examination/myPlan/index" */))
const _132e6e0f = () => interopDefault(import('../pages/index/examination/paper/index.vue' /* webpackChunkName: "pages/index/examination/paper/index" */))
const _dd299cc8 = () => interopDefault(import('../pages/index/examination/plan/index.vue' /* webpackChunkName: "pages/index/examination/plan/index" */))
const _7de68790 = () => interopDefault(import('../pages/index/examination/result/index.vue' /* webpackChunkName: "pages/index/examination/result/index" */))
const _6c40dcf2 = () => interopDefault(import('../pages/index/feedback/edit.vue' /* webpackChunkName: "pages/index/feedback/edit" */))
const _73da9932 = () => interopDefault(import('../pages/index/feedback/reply.vue' /* webpackChunkName: "pages/index/feedback/reply" */))
const _78dfe301 = () => interopDefault(import('../pages/index/generalService/baseDataManagement/index.vue' /* webpackChunkName: "pages/index/generalService/baseDataManagement/index" */))
const _d790b594 = () => interopDefault(import('../pages/index/generalService/cityImports/index.vue' /* webpackChunkName: "pages/index/generalService/cityImports/index" */))
const _3b562bf4 = () => interopDefault(import('../pages/index/generalService/disciplineCategoryManagement/index.vue' /* webpackChunkName: "pages/index/generalService/disciplineCategoryManagement/index" */))
const _8f41a8bc = () => interopDefault(import('../pages/index/generalService/hotSpot/index.vue' /* webpackChunkName: "pages/index/generalService/hotSpot/index" */))
const _4345d56b = () => interopDefault(import('../pages/index/generalService/onePointOneLevel/index.vue' /* webpackChunkName: "pages/index/generalService/onePointOneLevel/index" */))
const _b55afc5c = () => interopDefault(import('../pages/index/generalService/referenceScoreCalculate/index.vue' /* webpackChunkName: "pages/index/generalService/referenceScoreCalculate/index" */))
const _1ec90132 = () => interopDefault(import('../pages/index/generalService/relativeManagement/index.vue' /* webpackChunkName: "pages/index/generalService/relativeManagement/index" */))
const _05583e90 = () => interopDefault(import('../pages/index/generalService/subjectAssessDataManagement/index.vue' /* webpackChunkName: "pages/index/generalService/subjectAssessDataManagement/index" */))
const _5f67dd35 = () => interopDefault(import('../pages/index/generalService/supplementaryBaseScore/index.vue' /* webpackChunkName: "pages/index/generalService/supplementaryBaseScore/index" */))
const _3af7d7ce = () => interopDefault(import('../pages/index/generalService/trainingRecord/index.vue' /* webpackChunkName: "pages/index/generalService/trainingRecord/index" */))
const _312b0f77 = () => interopDefault(import('../pages/index/generalService/urbanCompetitiveness/index.vue' /* webpackChunkName: "pages/index/generalService/urbanCompetitiveness/index" */))
const _a3324224 = () => interopDefault(import('../pages/index/generalService/versionManagement/index.vue' /* webpackChunkName: "pages/index/generalService/versionManagement/index" */))
const _180c27b5 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index" */))
const _00b6784c = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/academyIntroduction.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/academyIntroduction" */))
const _6d436659 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/academyIntroduction_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/academyIntroduction_unreleased" */))
const _d81fcae0 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index/oralLanguage.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index/oralLanguage" */))
const _623807aa = () => interopDefault(import('../pages/index/hmtservice/index_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/index_unreleased" */))
const _7b89d6ac = () => interopDefault(import('../pages/index/hmtservice/scheme.vue' /* webpackChunkName: "pages/index/hmtservice/scheme" */))
const _1de74bf9 = () => interopDefault(import('../pages/index/hmtservice/scheme_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/scheme_unreleased" */))
const _3a48d032 = () => interopDefault(import('../pages/index/information/ArtScore/index.vue' /* webpackChunkName: "pages/index/information/ArtScore/index" */))
const _77dcbd78 = () => interopDefault(import('../pages/index/information/batch/index.vue' /* webpackChunkName: "pages/index/information/batch/index" */))
const _4a8411e0 = () => interopDefault(import('../pages/index/information/hmkColleges/index.vue' /* webpackChunkName: "pages/index/information/hmkColleges/index" */))
const _171bcd69 = () => interopDefault(import('../pages/index/information/newsList/index.vue' /* webpackChunkName: "pages/index/information/newsList/index" */))
const _5aa06f40 = () => interopDefault(import('../pages/index/information/onePointOneLevel/index.vue' /* webpackChunkName: "pages/index/information/onePointOneLevel/index" */))
const _03e88eb0 = () => interopDefault(import('../pages/index/information/Score/index.vue' /* webpackChunkName: "pages/index/information/Score/index" */))
const _c7b0ff26 = () => interopDefault(import('../pages/index/information/speciality/index.vue' /* webpackChunkName: "pages/index/information/speciality/index" */))
const _39acec64 = () => interopDefault(import('../pages/index/information/specialityinfoElective/index.vue' /* webpackChunkName: "pages/index/information/specialityinfoElective/index" */))
const _77622292 = () => interopDefault(import('../pages/index/information/studentList/index.vue' /* webpackChunkName: "pages/index/information/studentList/index" */))
const _4b959c68 = () => interopDefault(import('../pages/index/information/subjectAssessment/index.vue' /* webpackChunkName: "pages/index/information/subjectAssessment/index" */))
const _2667d57c = () => interopDefault(import('../pages/index/information/taiwanColleges/index.vue' /* webpackChunkName: "pages/index/information/taiwanColleges/index" */))
const _7d548666 = () => interopDefault(import('../pages/index/information/university/index.vue' /* webpackChunkName: "pages/index/information/university/index" */))
const _657401fc = () => interopDefault(import('../pages/index/IPADManage/agentProduce/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentProduce/index" */))
const _3be2b6a2 = () => interopDefault(import('../pages/index/IPADManage/campus-banner/index.vue' /* webpackChunkName: "pages/index/IPADManage/campus-banner/index" */))
const _5036b0df = () => interopDefault(import('../pages/index/IPADManage/campus-information/index.vue' /* webpackChunkName: "pages/index/IPADManage/campus-information/index" */))
const _c1dcb652 = () => interopDefault(import('../pages/index/IPADManage/caseClassification/index.vue' /* webpackChunkName: "pages/index/IPADManage/caseClassification/index" */))
const _3b510232 = () => interopDefault(import('../pages/index/IPADManage/classicCases/index.vue' /* webpackChunkName: "pages/index/IPADManage/classicCases/index" */))
const _13b1a0c5 = () => interopDefault(import('../pages/index/IPADManage/corporateCulture-banner/index.vue' /* webpackChunkName: "pages/index/IPADManage/corporateCulture-banner/index" */))
const _4c6f8d9e = () => interopDefault(import('../pages/index/IPADManage/corporateCulture-Images/index.vue' /* webpackChunkName: "pages/index/IPADManage/corporateCulture-Images/index" */))
const _5ec9b985 = () => interopDefault(import('../pages/index/IPADManage/IndexConfiguration/index.vue' /* webpackChunkName: "pages/index/IPADManage/IndexConfiguration/index" */))
const _3114fc96 = () => interopDefault(import('../pages/index/IPADManage/produce/index.vue' /* webpackChunkName: "pages/index/IPADManage/produce/index" */))
const _1ae8fc9e = () => interopDefault(import('../pages/index/lecturerApplication/application/index.vue' /* webpackChunkName: "pages/index/lecturerApplication/application/index" */))
const _2c7436b2 = () => interopDefault(import('../pages/index/lecturerApplication/applicationReport/index.vue' /* webpackChunkName: "pages/index/lecturerApplication/applicationReport/index" */))
const _383b3258 = () => interopDefault(import('../pages/index/log/loginLog.vue' /* webpackChunkName: "pages/index/log/loginLog" */))
const _493aaa2e = () => interopDefault(import('../pages/index/log/operLog.vue' /* webpackChunkName: "pages/index/log/operLog" */))
const _b545f9a2 = () => interopDefault(import('../pages/index/manageDepositX/orderListModal.vue' /* webpackChunkName: "pages/index/manageDepositX/orderListModal" */))
const _dcecc146 = () => interopDefault(import('../pages/index/manageMarginX/orderListModal.vue' /* webpackChunkName: "pages/index/manageMarginX/orderListModal" */))
const _303afcae = () => interopDefault(import('../pages/index/monthly/monthly.vue' /* webpackChunkName: "pages/index/monthly/monthly" */))
const _47419d8e = () => interopDefault(import('../pages/index/myToolBox/answers/index.vue' /* webpackChunkName: "pages/index/myToolBox/answers/index" */))
const _6c9cfb72 = () => interopDefault(import('../pages/index/myToolBox/carryForward/index.vue' /* webpackChunkName: "pages/index/myToolBox/carryForward/index" */))
const _76e28517 = () => interopDefault(import('../pages/index/myToolBox/informationPackage/index.vue' /* webpackChunkName: "pages/index/myToolBox/informationPackage/index" */))
const _67fc02d9 = () => interopDefault(import('../pages/index/myToolBox/libraryManage/index.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/index" */))
const _42da2b52 = () => interopDefault(import('../pages/index/myToolBox/mailList/index.vue' /* webpackChunkName: "pages/index/myToolBox/mailList/index" */))
const _8011e552 = () => interopDefault(import('../pages/index/myToolBox/mailListManage/index.vue' /* webpackChunkName: "pages/index/myToolBox/mailListManage/index" */))
const _6645e188 = () => interopDefault(import('../pages/index/myToolBox/product/index.vue' /* webpackChunkName: "pages/index/myToolBox/product/index" */))
const _61cf2194 = () => interopDefault(import('../pages/index/myToolBox/video/index.vue' /* webpackChunkName: "pages/index/myToolBox/video/index" */))
const _91bc2454 = () => interopDefault(import('../pages/index/opportunityPoint/opportunity/index.vue' /* webpackChunkName: "pages/index/opportunityPoint/opportunity/index" */))
const _bc40704e = () => interopDefault(import('../pages/index/order/failOrders/index.vue' /* webpackChunkName: "pages/index/order/failOrders/index" */))
const _32ccd24e = () => interopDefault(import('../pages/index/order/onlineOrders/index.vue' /* webpackChunkName: "pages/index/order/onlineOrders/index" */))
const _1b1cf321 = () => interopDefault(import('../pages/index/order/onlineRefund/index.vue' /* webpackChunkName: "pages/index/order/onlineRefund/index" */))
const _37e19018 = () => interopDefault(import('../pages/index/order/pos/index.vue' /* webpackChunkName: "pages/index/order/pos/index" */))
const _3148071f = () => interopDefault(import('../pages/index/order/productChange/index.vue' /* webpackChunkName: "pages/index/order/productChange/index" */))
const _d1432224 = () => interopDefault(import('../pages/index/order/refund/index.vue' /* webpackChunkName: "pages/index/order/refund/index" */))
const _656cfb6c = () => interopDefault(import('../pages/index/order/sales/index.vue' /* webpackChunkName: "pages/index/order/sales/index" */))
const _3398d457 = () => interopDefault(import('../pages/index/order/touristOrders/index.vue' /* webpackChunkName: "pages/index/order/touristOrders/index" */))
const _0309e74b = () => interopDefault(import('../pages/index/padManage/campus/index.vue' /* webpackChunkName: "pages/index/padManage/campus/index" */))
const _14ffb2ae = () => interopDefault(import('../pages/index/padManage/group/index.vue' /* webpackChunkName: "pages/index/padManage/group/index" */))
const _02fa99c6 = () => interopDefault(import('../pages/index/padManage/inventory/index.vue' /* webpackChunkName: "pages/index/padManage/inventory/index" */))
const _08a49824 = () => interopDefault(import('../pages/index/product/offline/index.vue' /* webpackChunkName: "pages/index/product/offline/index" */))
const _c23541d2 = () => interopDefault(import('../pages/index/product/stock/index.vue' /* webpackChunkName: "pages/index/product/stock/index" */))
const _5696f8c0 = () => interopDefault(import('../pages/index/quickReferenceTable/add.vue' /* webpackChunkName: "pages/index/quickReferenceTable/add" */))
const _61fd15a2 = () => interopDefault(import('../pages/index/quickReferenceTable/quickReferenceTable.vue' /* webpackChunkName: "pages/index/quickReferenceTable/quickReferenceTable" */))
const _9f904db4 = () => interopDefault(import('../pages/index/report/achievement.vue' /* webpackChunkName: "pages/index/report/achievement" */))
const _73139031 = () => interopDefault(import('../pages/index/report/campusPerformanceSummary/index.vue' /* webpackChunkName: "pages/index/report/campusPerformanceSummary/index" */))
const _059c8064 = () => interopDefault(import('../pages/index/report/customerStatisticsReport.vue' /* webpackChunkName: "pages/index/report/customerStatisticsReport" */))
const _15e7f8df = () => interopDefault(import('../pages/index/report/education.vue' /* webpackChunkName: "pages/index/report/education" */))
const _46633f0b = () => interopDefault(import('../pages/index/report/expendReport.vue' /* webpackChunkName: "pages/index/report/expendReport" */))
const _75d27d40 = () => interopDefault(import('../pages/index/report/headquarters.vue' /* webpackChunkName: "pages/index/report/headquarters" */))
const _742427a3 = () => interopDefault(import('../pages/index/report/intenReport.vue' /* webpackChunkName: "pages/index/report/intenReport" */))
const _73e7cc6e = () => interopDefault(import('../pages/index/report/lecturerPerformanceRankingTable/index.vue' /* webpackChunkName: "pages/index/report/lecturerPerformanceRankingTable/index" */))
const _21ed0272 = () => interopDefault(import('../pages/index/report/operationalPerformanceRankingTable/index.vue' /* webpackChunkName: "pages/index/report/operationalPerformanceRankingTable/index" */))
const _3b18f382 = () => interopDefault(import('../pages/index/report/operationsManagerPerformanceReport/index.vue' /* webpackChunkName: "pages/index/report/operationsManagerPerformanceReport/index" */))
const _62791fda = () => interopDefault(import('../pages/index/report/orderListModal.vue' /* webpackChunkName: "pages/index/report/orderListModal" */))
const _84e4a004 = () => interopDefault(import('../pages/index/report/performanceReport/index.vue' /* webpackChunkName: "pages/index/report/performanceReport/index" */))
const _3d137970 = () => interopDefault(import('../pages/index/report/performanceReportJoin/index.vue' /* webpackChunkName: "pages/index/report/performanceReportJoin/index" */))
const _5403fe05 = () => interopDefault(import('../pages/index/report/productLineTransfer.vue' /* webpackChunkName: "pages/index/report/productLineTransfer" */))
const _0c1421d0 = () => interopDefault(import('../pages/index/report/proIntenReport.vue' /* webpackChunkName: "pages/index/report/proIntenReport" */))
const _c46edf60 = () => interopDefault(import('../pages/index/report/salesSummaryB2C.vue' /* webpackChunkName: "pages/index/report/salesSummaryB2C" */))
const _71e5b6a9 = () => interopDefault(import('../pages/index/report/serviceNumberReport.vue' /* webpackChunkName: "pages/index/report/serviceNumberReport" */))
const _592df38d = () => interopDefault(import('../pages/index/report/serviceProgressReport.vue' /* webpackChunkName: "pages/index/report/serviceProgressReport" */))
const _ea814500 = () => interopDefault(import('../pages/index/report/serviceReport.vue' /* webpackChunkName: "pages/index/report/serviceReport" */))
const _6cff376c = () => interopDefault(import('../pages/index/report/serviceStepReport.vue' /* webpackChunkName: "pages/index/report/serviceStepReport" */))
const _fe00e9cc = () => interopDefault(import('../pages/index/report/teacherAchievementReport.vue' /* webpackChunkName: "pages/index/report/teacherAchievementReport" */))
const _7e6de081 = () => interopDefault(import('../pages/index/report/variousRegionsReport.vue' /* webpackChunkName: "pages/index/report/variousRegionsReport" */))
const _26d1ef54 = () => interopDefault(import('../pages/index/revenues/paymentRecord/index.vue' /* webpackChunkName: "pages/index/revenues/paymentRecord/index" */))
const _fd776afc = () => interopDefault(import('../pages/index/revenues/refundRecord/index.vue' /* webpackChunkName: "pages/index/revenues/refundRecord/index" */))
const _2179a575 = () => interopDefault(import('../pages/index/revenues/transferRecord/index.vue' /* webpackChunkName: "pages/index/revenues/transferRecord/index" */))
const _04882293 = () => interopDefault(import('../pages/index/selfService/planStore/index.vue' /* webpackChunkName: "pages/index/selfService/planStore/index" */))
const _0e43bd12 = () => interopDefault(import('../pages/index/selfService/programme/index.vue' /* webpackChunkName: "pages/index/selfService/programme/index" */))
const _da6a5384 = () => interopDefault(import('../pages/index/serviceSystem/career/index.vue' /* webpackChunkName: "pages/index/serviceSystem/career/index" */))
const _47753aff = () => interopDefault(import('../pages/index/serviceSystem/entrancePlanningMap/index.vue' /* webpackChunkName: "pages/index/serviceSystem/entrancePlanningMap/index" */))
const _41280864 = () => interopDefault(import('../pages/index/serviceSystem/learnMethods/index.vue' /* webpackChunkName: "pages/index/serviceSystem/learnMethods/index" */))
const _496e3cec = () => interopDefault(import('../pages/index/serviceSystem/learnStatus/index.vue' /* webpackChunkName: "pages/index/serviceSystem/learnStatus/index" */))
const _73bd7745 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/index" */))
const _350dbfe3 = () => interopDefault(import('../pages/index/serviceSystem/serviceConditions/index.vue' /* webpackChunkName: "pages/index/serviceSystem/serviceConditions/index" */))
const _729efa40 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/index.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/index" */))
const _7eff8036 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/index" */))
const _79505400 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan-xk/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan-xk/index" */))
const _0f839592 = () => interopDefault(import('../pages/index/stationNotification/myReceived/index.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/index" */))
const _55a71468 = () => interopDefault(import('../pages/index/stationNotification/myRelease/index.vue' /* webpackChunkName: "pages/index/stationNotification/myRelease/index" */))
const _5046268a = () => interopDefault(import('../pages/index/stationNotification/taskSituation/index.vue' /* webpackChunkName: "pages/index/stationNotification/taskSituation/index" */))
const _04caf2a6 = () => interopDefault(import('../pages/index/system/configs/index.vue' /* webpackChunkName: "pages/index/system/configs/index" */))
const _aded3ec0 = () => interopDefault(import('../pages/index/system/menu/index.vue' /* webpackChunkName: "pages/index/system/menu/index" */))
const _19ba8559 = () => interopDefault(import('../pages/index/system/org/index.vue' /* webpackChunkName: "pages/index/system/org/index" */))
const _05ce1af7 = () => interopDefault(import('../pages/index/system/role/index.vue' /* webpackChunkName: "pages/index/system/role/index" */))
const _a7f62e8e = () => interopDefault(import('../pages/index/test/crud.vue' /* webpackChunkName: "pages/index/test/crud" */))
const _1d083226 = () => interopDefault(import('../pages/index/weekly/weekly.vue' /* webpackChunkName: "pages/index/weekly/weekly" */))
const _877d84dc = () => interopDefault(import('../pages/index/workbench/approvalDealtService.vue' /* webpackChunkName: "pages/index/workbench/approvalDealtService" */))
const _17b9f8b1 = () => interopDefault(import('../pages/index/workbench/eduDealtService.vue' /* webpackChunkName: "pages/index/workbench/eduDealtService" */))
const _380e93b1 = () => interopDefault(import('../pages/index/workbench/finishedService.vue' /* webpackChunkName: "pages/index/workbench/finishedService" */))
const _1b268a6f = () => interopDefault(import('../pages/index/workbench/handleDone/index.vue' /* webpackChunkName: "pages/index/workbench/handleDone/index" */))
const _2673bbd7 = () => interopDefault(import('../pages/index/workbench/myToDo/index.vue' /* webpackChunkName: "pages/index/workbench/myToDo/index" */))
const _34f567fa = () => interopDefault(import('../pages/index/workbench/notice.vue' /* webpackChunkName: "pages/index/workbench/notice" */))
const _22f3ee25 = () => interopDefault(import('../pages/index/workbench/noticeAdmin.vue' /* webpackChunkName: "pages/index/workbench/noticeAdmin" */))
const _606ff887 = () => interopDefault(import('../pages/index/workbench/salesDealtService.vue' /* webpackChunkName: "pages/index/workbench/salesDealtService" */))
const _61810eb0 = () => interopDefault(import('../pages/index/workbench/serviceDealtService.vue' /* webpackChunkName: "pages/index/workbench/serviceDealtService" */))
const _3e5c39b3 = () => interopDefault(import('../pages/index/artExamination/university/orderListModal.vue' /* webpackChunkName: "pages/index/artExamination/university/orderListModal" */))
const _66ecf15d = () => interopDefault(import('../pages/index/artExamination/university/orderListModalEdit.vue' /* webpackChunkName: "pages/index/artExamination/university/orderListModalEdit" */))
const _65c1bab8 = () => interopDefault(import('../pages/index/customer/livingCustomer/customerListModal.vue' /* webpackChunkName: "pages/index/customer/livingCustomer/customerListModal" */))
const _fcb4bf62 = () => interopDefault(import('../pages/index/customer/zonghe/honourPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/honourPreviewModal" */))
const _157efcc1 = () => interopDefault(import('../pages/index/customer/zonghe/newPassPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/newPassPreviewModal" */))
const _1dfe77c8 = () => interopDefault(import('../pages/index/customer/zonghe/oldPassPreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/oldPassPreviewModal" */))
const _09a446b6 = () => interopDefault(import('../pages/index/customer/zonghe/practicePreviewModal.vue' /* webpackChunkName: "pages/index/customer/zonghe/practicePreviewModal" */))
const _e0d87674 = () => interopDefault(import('../pages/index/examination/analysis/viewInfo.vue' /* webpackChunkName: "pages/index/examination/analysis/viewInfo" */))
const _3042205e = () => interopDefault(import('../pages/index/generalService/hotSpot/hotSpotModal.vue' /* webpackChunkName: "pages/index/generalService/hotSpot/hotSpotModal" */))
const _74259f95 = () => interopDefault(import('../pages/index/hmtservice/application/addApplication.vue' /* webpackChunkName: "pages/index/hmtservice/application/addApplication" */))
const _51fa841a = () => interopDefault(import('../pages/index/hmtservice/application/application.vue' /* webpackChunkName: "pages/index/hmtservice/application/application" */))
const _7c6b46cf = () => interopDefault(import('../pages/index/hmtservice/application/backMaterials.vue' /* webpackChunkName: "pages/index/hmtservice/application/backMaterials" */))
const _25125576 = () => interopDefault(import('../pages/index/hmtservice/application/materials.vue' /* webpackChunkName: "pages/index/hmtservice/application/materials" */))
const _7d38077c = () => interopDefault(import('../pages/index/hmtservice/application/pushMaterials.vue' /* webpackChunkName: "pages/index/hmtservice/application/pushMaterials" */))
const _1dde7e74 = () => interopDefault(import('../pages/index/hmtservice/coverLetter/coverLetter.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/coverLetter" */))
const _f1ec0a9e = () => interopDefault(import('../pages/index/hmtservice/coverLetter/guidance.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/guidance" */))
const _b2d77d8c = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upLoad.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upLoad" */))
const _7fe9456c = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upSignup.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upSignup" */))
const _2241d0a4 = () => interopDefault(import('../pages/index/hmtservice/coverLetter/upSignUpNew.vue' /* webpackChunkName: "pages/index/hmtservice/coverLetter/upSignUpNew" */))
const _76b72b50 = () => interopDefault(import('../pages/index/hmtservice/englishVideo/index_unreleased.vue' /* webpackChunkName: "pages/index/hmtservice/englishVideo/index_unreleased" */))
const _76b16738 = () => interopDefault(import('../pages/index/hmtservice/interviwe/addAdmissionModel.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/addAdmissionModel" */))
const _3a7d47ce = () => interopDefault(import('../pages/index/hmtservice/interviwe/addTrainModel.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/addTrainModel" */))
const _316f5ac0 = () => interopDefault(import('../pages/index/hmtservice/interviwe/admission.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/admission" */))
const _10348fb2 = () => interopDefault(import('../pages/index/hmtservice/interviwe/admissionStatus.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/admissionStatus" */))
const _695df986 = () => interopDefault(import('../pages/index/hmtservice/interviwe/materials/index.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/materials/index" */))
const _ee36eb38 = () => interopDefault(import('../pages/index/hmtservice/interviwe/trainManage.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/trainManage" */))
const _79b003e8 = () => interopDefault(import('../pages/index/hmtservice/interviwe/trainPlan.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/trainPlan" */))
const _2b536e95 = () => interopDefault(import('../pages/index/hmtservice/interviwe/video/index.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/video/index" */))
const _66f8abb4 = () => interopDefault(import('../pages/index/hmtservice/plan/HM.vue' /* webpackChunkName: "pages/index/hmtservice/plan/HM" */))
const _6f493f75 = () => interopDefault(import('../pages/index/hmtservice/plan/T.vue' /* webpackChunkName: "pages/index/hmtservice/plan/T" */))
const _325d9fca = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCardManage/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCardManage/index" */))
const _4864a35a = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/index" */))
const _9a5d2ba6 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentInformation/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentInformation/index" */))
const _1b516c13 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentList/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentList/index" */))
const _771e93b9 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/index" */))
const _aa589022 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/index" */))
const _fc41d71c = () => interopDefault(import('../pages/index/IPADManage/agentManage/cardUsageRecord/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/cardUsageRecord/index" */))
const _88c9f4f0 = () => interopDefault(import('../pages/index/IPADManage/agentManage/orgProductOffline/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/orgProductOffline/index" */))
const _73a60b78 = () => interopDefault(import('../pages/index/IPADManage/agentManage/productManage/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/productManage/index" */))
const _40bf849a = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueBreakdownQuery/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueBreakdownQuery/index" */))
const _76450e92 = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueQuery/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueQuery/index" */))
const _04456dc4 = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/index.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/index" */))
const _c32bf050 = () => interopDefault(import('../pages/index/notice/components/orderNotification/index.vue' /* webpackChunkName: "pages/index/notice/components/orderNotification/index" */))
const _1cb81757 = () => interopDefault(import('../pages/index/noticeOnline/components/myReceived/index.vue' /* webpackChunkName: "pages/index/noticeOnline/components/myReceived/index" */))
const _4b9c5dbe = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/index.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/index" */))
const _abbcadb6 = () => interopDefault(import('../pages/index/opportunityPoint/opportunity/add.vue' /* webpackChunkName: "pages/index/opportunityPoint/opportunity/add" */))
const _5f8efdc4 = () => interopDefault(import('../pages/index/product/offline/productListModal.vue' /* webpackChunkName: "pages/index/product/offline/productListModal" */))
const _85228c5e = () => interopDefault(import('../pages/index/product/stock/addStockDrawer.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawer" */))
const _049041ea = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForArt.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForArt" */))
const _635ea248 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForSchoolPartner.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForSchoolPartner" */))
const _226c0dc4 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForZP.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForZP" */))
const _753aeb34 = () => interopDefault(import('../pages/index/product/stock/addStockDrawerForZPSchoolPartner.vue' /* webpackChunkName: "pages/index/product/stock/addStockDrawerForZPSchoolPartner" */))
const _708405e8 = () => interopDefault(import('../pages/index/product/stock/orderListModal.vue' /* webpackChunkName: "pages/index/product/stock/orderListModal" */))
const _744f2534 = () => interopDefault(import('../pages/index/product/stock/RefundStockDrawer.vue' /* webpackChunkName: "pages/index/product/stock/RefundStockDrawer" */))
const _489a8425 = () => interopDefault(import('../pages/index/product/stock/selectProductModal.vue' /* webpackChunkName: "pages/index/product/stock/selectProductModal" */))
const _397eccb3 = () => interopDefault(import('../pages/index/product/stock/stockRefund.vue' /* webpackChunkName: "pages/index/product/stock/stockRefund" */))
const _51dd343f = () => interopDefault(import('../pages/index/reconcilation/components/table-expand.vue' /* webpackChunkName: "pages/index/reconcilation/components/table-expand" */))
const _3ca5dffa = () => interopDefault(import('../pages/index/selfService/components/DesignThoughtModal.vue' /* webpackChunkName: "pages/index/selfService/components/DesignThoughtModal" */))
const _0637e2bc = () => interopDefault(import('../pages/index/selfService/components/LeaveMessageModal.vue' /* webpackChunkName: "pages/index/selfService/components/LeaveMessageModal" */))
const _633a82c6 = () => interopDefault(import('../pages/index/selfService/components/seniority.vue' /* webpackChunkName: "pages/index/selfService/components/seniority" */))
const _8209f730 = () => interopDefault(import('../pages/index/selfService/components/studentInfo.vue' /* webpackChunkName: "pages/index/selfService/components/studentInfo" */))
const _154364a7 = () => interopDefault(import('../pages/index/selfService/stepFive/confirmationPlan.vue' /* webpackChunkName: "pages/index/selfService/stepFive/confirmationPlan" */))
const _b555b656 = () => interopDefault(import('../pages/index/selfService/stepFive/finalSolutionLibrary.vue' /* webpackChunkName: "pages/index/selfService/stepFive/finalSolutionLibrary" */))
const _dc8a9b8a = () => interopDefault(import('../pages/index/selfService/stepFive/universityBrochure.vue' /* webpackChunkName: "pages/index/selfService/stepFive/universityBrochure" */))
const _62972338 = () => interopDefault(import('../pages/index/selfService/stepFour/addApplication.vue' /* webpackChunkName: "pages/index/selfService/stepFour/addApplication" */))
const _3b203bc0 = () => interopDefault(import('../pages/index/selfService/stepFour/backMaterials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/backMaterials" */))
const _82028ad0 = () => interopDefault(import('../pages/index/selfService/stepFour/coverLetter.vue' /* webpackChunkName: "pages/index/selfService/stepFour/coverLetter" */))
const _007fddd4 = () => interopDefault(import('../pages/index/selfService/stepFour/guideVideo.vue' /* webpackChunkName: "pages/index/selfService/stepFour/guideVideo" */))
const _eff97d72 = () => interopDefault(import('../pages/index/selfService/stepFour/materials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/materials" */))
const _3986ba66 = () => interopDefault(import('../pages/index/selfService/stepFour/pushMaterials.vue' /* webpackChunkName: "pages/index/selfService/stepFour/pushMaterials" */))
const _04f1a532 = () => interopDefault(import('../pages/index/selfService/stepSix/fillinVideo.vue' /* webpackChunkName: "pages/index/selfService/stepSix/fillinVideo" */))
const _3bfba5bc = () => interopDefault(import('../pages/index/selfService/stepSix/schemeScreenshot.vue' /* webpackChunkName: "pages/index/selfService/stepSix/schemeScreenshot" */))
const _ac70999c = () => interopDefault(import('../pages/index/selfService/stepSix/upLoad.vue' /* webpackChunkName: "pages/index/selfService/stepSix/upLoad" */))
const _6824af36 = () => interopDefault(import('../pages/index/selfService/stepThree/planStore/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/planStore/index" */))
const _962cd84c = () => interopDefault(import('../pages/index/selfService/stepThree/recruitment/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/recruitment/index" */))
const _0545eef5 = () => interopDefault(import('../pages/index/selfService/stepThree/recruitStudent/index.vue' /* webpackChunkName: "pages/index/selfService/stepThree/recruitStudent/index" */))
const _265f1dc6 = () => interopDefault(import('../pages/index/selfService/stepTwo/guideVideo.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/guideVideo" */))
const _98359ea4 = () => interopDefault(import('../pages/index/selfService/stepTwo/match.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/match" */))
const _d5b98da4 = () => interopDefault(import('../pages/index/selfService/stepTwo/planDesign.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/planDesign" */))
const _61e00332 = () => interopDefault(import('../pages/index/selfService/stepTwo/seniority.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/seniority" */))
const _219cd936 = () => interopDefault(import('../pages/index/selfService/stepTwo/studentPassageway.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/studentPassageway" */))
const _0138e816 = () => interopDefault(import('../pages/index/selfService/stepTwo/videoDrawer.vue' /* webpackChunkName: "pages/index/selfService/stepTwo/videoDrawer" */))
const _16156ee2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/citySelect.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/citySelect" */))
const _d23e9cb0 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/complateServiceModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/complateServiceModal" */))
const _14143f30 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThought.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThought" */))
const _7ce9986a = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThoughtForOp.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThoughtForOp" */))
const _57fbc0af = () => interopDefault(import('../pages/index/serviceSystem/commonFile/designThoughtForSpecal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/designThoughtForSpecal" */))
const _7dd0fc24 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/exportOption.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/exportOption" */))
const _12aeecb5 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/scoreStatisticsListModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/scoreStatisticsListModal" */))
const _79605fd4 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/serviceStep.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/serviceStep" */))
const _2f839f34 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityPackage.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityPackage" */))
const _37091c34 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityPackageaAdd.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityPackageaAdd" */))
const _4981474f = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityTreeModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityTreeModal" */))
const _3e70df42 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialityTreeNew.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialityTreeNew" */))
const _e573adc2 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/specialRequirementsModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/specialRequirementsModal" */))
const _5d317b04 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentInfo" */))
const _73a0bdae = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentInfoDetailModal.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentInfoDetailModal" */))
const _1701166e = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentList.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentList" */))
const _72a4e319 = () => interopDefault(import('../pages/index/serviceSystem/commonFile/studentUpdate.vue' /* webpackChunkName: "pages/index/serviceSystem/commonFile/studentUpdate" */))
const _67294ad4 = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/index" */))
const _04b84390 = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/index" */))
const _2b6f16c2 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/index" */))
const _0cf0e455 = () => interopDefault(import('../pages/index/serviceSystem/general-province/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/scheme/index" */))
const _548b44e8 = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/index" */))
const _64b3c8a0 = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/index" */))
const _1b377944 = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/index" */))
const _c210a114 = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/index" */))
const _d391d7ee = () => interopDefault(import('../pages/index/serviceSystem/new-version/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/scheme/index" */))
const _6fd844c8 = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/index" */))
const _8846d1c8 = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/estimate-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/estimate-plan" */))
const _726206bc = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/final-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/final-plan" */))
const _48b907d8 = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/initial-plan" */))
const _7fd107a7 = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/scheme.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/scheme" */))
const _9648ae1c = () => interopDefault(import('../pages/index/serviceSystem/occupations/occupation/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/occupation/index" */))
const _01de48f8 = () => interopDefault(import('../pages/index/serviceSystem/occupations/planning/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/planning/index" */))
const _244d8b9b = () => interopDefault(import('../pages/index/serviceSystem/occupations/report/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/report/index" */))
const _123d52cc = () => interopDefault(import('../pages/index/serviceSystem/occupations/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/occupations/scheme/index" */))
const _6cbda145 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/scheme/index" */))
const _fe3e0f66 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/estimate-plan/index" */))
const _2f0f30b7 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/final-plan/index" */))
const _1bbf5629 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/initial-plan/index" */))
const _10a27cfc = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/scheme/index" */))
const _0a91a039 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/estimate-plan/index" */))
const _0685704b = () => interopDefault(import('../pages/index/serviceSystem/professionNew/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/final-plan/index" */))
const _22b7fe86 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/initial-plan/index" */))
const _6cafa690 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/scheme/index" */))
const _4a007728 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/edit.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/edit" */))
const _7a6c68f2 = () => interopDefault(import('../pages/index/serviceSystem/volunteer/view.vue' /* webpackChunkName: "pages/index/serviceSystem/volunteer/view" */))
const _1f564821 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/designThought.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/designThought" */))
const _6cec7e19 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/designThoughtForOp.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/designThoughtForOp" */))
const _3b22f562 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hm.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hm" */))
const _15bc4cbe = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmDesignThoughtModal.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmDesignThoughtModal" */))
const _13572544 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmLeaveMessageModal.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmLeaveMessageModal" */))
const _2cf11ba9 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmPreview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmPreview" */))
const _e2f9d158 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/hmScheme.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/hmScheme" */))
const _be9d3d72 = () => interopDefault(import('../pages/index/serviceSystemArt/commonFile/serviceStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/commonFile/serviceStep" */))
const _40f87245 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/index" */))
const _6f3a8c82 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/index" */))
const _a356859e = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/index" */))
const _06186bf8 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/scheme/index" */))
const _511e2952 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/index" */))
const _3869d478 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/estimate-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/estimate-plan" */))
const _fa6d820c = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/final-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/final-plan" */))
const _fbd2ef28 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/initial-plan" */))
const _e98b9402 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/scheme.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/scheme" */))
const _5f93fe8f = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/index" */))
const _3379a1b5 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/index" */))
const _a15d00b2 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/index" */))
const _bd0dc60c = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/scheme/index" */))
const _4f24a466 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/index" */))
const _65c45d3a = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/occupation/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/occupation/index" */))
const _41f46c35 = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/planning/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/planning/index" */))
const _2f8f948c = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/report/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/report/index" */))
const _1d7f5bbd = () => interopDefault(import('../pages/index/serviceSystemArt/occupations/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/occupations/scheme/index" */))
const _7a11e7ac = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan-xk/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan-xk/scheme/index" */))
const _308dee5b = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/page.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/page" */))
const _679dd734 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/scheme/index.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/scheme/index" */))
const _aa384e9e = () => interopDefault(import('../pages/index/serviceSystemArt/serviceConditions/1.vue' /* webpackChunkName: "pages/index/serviceSystemArt/serviceConditions/1" */))
const _1e9d7ca7 = () => interopDefault(import('../pages/index/aiReporting/appletProductShare/component/editDrawer.vue' /* webpackChunkName: "pages/index/aiReporting/appletProductShare/component/editDrawer" */))
const _ad0be538 = () => interopDefault(import('../pages/index/aiReporting/creditCards/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/creditCards/componts/editDialog" */))
const _827ae4b0 = () => interopDefault(import('../pages/index/aiReporting/feedbackStatistics/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/feedbackStatistics/componts/editDialog" */))
const _2f407caa = () => interopDefault(import('../pages/index/aiReporting/gptfeedback/componts/editDialog.vue' /* webpackChunkName: "pages/index/aiReporting/gptfeedback/componts/editDialog" */))
const _770ba778 = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/addModal.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/addModal" */))
const _f2054e5c = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/codeLibrary.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/codeLibrary" */))
const _6220be11 = () => interopDefault(import('../pages/index/aiReporting/headQuarters/components/vipCard.vue' /* webpackChunkName: "pages/index/aiReporting/headQuarters/components/vipCard" */))
const _ea9a0dae = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/addModal.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/addModal" */))
const _b9ce44fe = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/codeLibrary.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/codeLibrary" */))
const _efa355a6 = () => interopDefault(import('../pages/index/aiReporting/redemptionCode/components/vipModal.vue' /* webpackChunkName: "pages/index/aiReporting/redemptionCode/components/vipModal" */))
const _33e8c2de = () => interopDefault(import('../pages/index/aiReporting/timeAxis/components/timeDrawer.vue' /* webpackChunkName: "pages/index/aiReporting/timeAxis/components/timeDrawer" */))
const _50327a81 = () => interopDefault(import('../pages/index/artExamination/academic/components/add.vue' /* webpackChunkName: "pages/index/artExamination/academic/components/add" */))
const _77227440 = () => interopDefault(import('../pages/index/artExamination/onePointOneLevelArt/components/edit.vue' /* webpackChunkName: "pages/index/artExamination/onePointOneLevelArt/components/edit" */))
const _aee3a294 = () => interopDefault(import('../pages/index/artExamination/policy/components/add.vue' /* webpackChunkName: "pages/index/artExamination/policy/components/add" */))
const _0cd4444f = () => interopDefault(import('../pages/index/company/courselearning/components/editCategory.vue' /* webpackChunkName: "pages/index/company/courselearning/components/editCategory" */))
const _c6bd17a6 = () => interopDefault(import('../pages/index/company/CourseLearningProgress/components/table-expand.vue' /* webpackChunkName: "pages/index/company/CourseLearningProgress/components/table-expand" */))
const _18edc134 = () => interopDefault(import('../pages/index/comprehensive/application/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/application/components/add" */))
const _0d45eea7 = () => interopDefault(import('../pages/index/comprehensive/coverLetter/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/coverLetter/components/add" */))
const _68b88aa0 = () => interopDefault(import('../pages/index/comprehensive/matchIntroduce/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/matchIntroduce/components/add" */))
const _fe2eb6fc = () => interopDefault(import('../pages/index/comprehensive/qualitySpecialityInfo/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/qualitySpecialityInfo/components/add" */))
const _e5c8aaf2 = () => interopDefault(import('../pages/index/comprehensive/universityManage/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/universityManage/components/add" */))
const _238c2a26 = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/add.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/add" */))
const _408d37a3 = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/player.js' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/player" */))
const _0ad0e37e = () => interopDefault(import('../pages/index/comprehensive/videoManagement/components/videoList.vue' /* webpackChunkName: "pages/index/comprehensive/videoManagement/components/videoList" */))
const _2a3e7cd6 = () => interopDefault(import('../pages/index/generalService/disciplineCategoryManagement/components/updateDrawer.vue' /* webpackChunkName: "pages/index/generalService/disciplineCategoryManagement/components/updateDrawer" */))
const _5017219c = () => interopDefault(import('../pages/index/hmtservice/interviwe/materials/addMaterial.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/materials/addMaterial" */))
const _84484462 = () => interopDefault(import('../pages/index/hmtservice/interviwe/video/videoDrawer.vue' /* webpackChunkName: "pages/index/hmtservice/interviwe/video/videoDrawer" */))
const _92801a98 = () => interopDefault(import('../pages/index/information/newsList/components/newsDetail.vue' /* webpackChunkName: "pages/index/information/newsList/components/newsDetail" */))
const _3b0973ca = () => interopDefault(import('../pages/index/information/newsList/components/push.vue' /* webpackChunkName: "pages/index/information/newsList/components/push" */))
const _37055ef6 = () => interopDefault(import('../pages/index/information/speciality/components/detail.vue' /* webpackChunkName: "pages/index/information/speciality/components/detail" */))
const _6ae431ce = () => interopDefault(import('../pages/index/information/speciality/components/push.vue' /* webpackChunkName: "pages/index/information/speciality/components/push" */))
const _1af7937a = () => interopDefault(import('../pages/index/myToolBox/answers/components/editClassify.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/editClassify" */))
const _6109970a = () => interopDefault(import('../pages/index/myToolBox/answers/components/editDescribe.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/editDescribe" */))
const _18e3621a = () => interopDefault(import('../pages/index/myToolBox/answers/components/feedback.vue' /* webpackChunkName: "pages/index/myToolBox/answers/components/feedback" */))
const _b525d770 = () => interopDefault(import('../pages/index/myToolBox/libraryManage/components/editCategory.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/components/editCategory" */))
const _2a6f6fe1 = () => interopDefault(import('../pages/index/myToolBox/libraryManage/components/editLibrary.vue' /* webpackChunkName: "pages/index/myToolBox/libraryManage/components/editLibrary" */))
const _0099ff98 = () => interopDefault(import('../pages/index/notice/components/stationNotification/myReceived/index.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myReceived/index" */))
const _0417a22c = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/index.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/index" */))
const _7e06bfc2 = () => interopDefault(import('../pages/index/padManage/inventory/components/balance.vue' /* webpackChunkName: "pages/index/padManage/inventory/components/balance" */))
const _5e002c5e = () => interopDefault(import('../pages/index/padManage/inventory/components/detail.vue' /* webpackChunkName: "pages/index/padManage/inventory/components/detail" */))
const _02a40b1b = () => interopDefault(import('../pages/index/selfService/components/stepThree/recruitmentModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepThree/recruitmentModel" */))
const _6b552bb8 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/excellentList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/excellentList" */))
const _54162913 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/excellentModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/excellentModel" */))
const _3807c92c = () => interopDefault(import('../pages/index/selfService/components/stepTwo/passwayList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/passwayList" */))
const _c6a0a9ea = () => interopDefault(import('../pages/index/selfService/components/stepTwo/passwayModel.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/passwayModel" */))
const _73f54328 = () => interopDefault(import('../pages/index/selfService/components/stepTwo/seniorityList.vue' /* webpackChunkName: "pages/index/selfService/components/stepTwo/seniorityList" */))
const _c834cd5c = () => interopDefault(import('../pages/index/selfService/stepFive/components/DesignThoughtModal.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/DesignThoughtModal" */))
const _299d18e6 = () => interopDefault(import('../pages/index/selfService/stepFive/components/LeaveMessageModal.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/LeaveMessageModal" */))
const _14ba4fad = () => interopDefault(import('../pages/index/selfService/stepFive/components/recruitmentModel.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/recruitmentModel" */))
const _7f61c5f9 = () => interopDefault(import('../pages/index/selfService/stepFive/components/studentInfo.vue' /* webpackChunkName: "pages/index/selfService/stepFive/components/studentInfo" */))
const _45b44904 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/downloadPDF" */))
const _8f68ed1c = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/downloadPDFNew.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/downloadPDFNew" */))
const _1ec876b6 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/leave-message" */))
const _5f06bb88 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/newPlan-by-lastStep" */))
const _c20f2330 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/scheme-inspect" */))
const _5529ab86 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/studentInfo" */))
const _d6ff8738 = () => interopDefault(import('../pages/index/serviceSystem/general-province/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/components/visable-field-config" */))
const _55562b4e = () => interopDefault(import('../pages/index/serviceSystem/general-province/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/general-province/utils/utils" */))
const _fde3215c = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/design-thought.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/design-thought" */))
const _f997f34e = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/leave-message" */))
const _468be63c = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/newPlan-by-lastStep" */))
const _5f686334 = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/scheme-inspect" */))
const _a65f6e1e = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/studentInfo" */))
const _c4bf2fa0 = () => interopDefault(import('../pages/index/serviceSystem/new-version/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/components/visable-field-config" */))
const _9be911e6 = () => interopDefault(import('../pages/index/serviceSystem/new-version/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/new-version/utils/utils" */))
const _53b0891a = () => interopDefault(import('../pages/index/serviceSystem/newRegulation/downloadPDF/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/newRegulation/downloadPDF/downloadPDF" */))
const _5bf6ccd6 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/leave-message" */))
const _0e7281a8 = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/scheme-preview" */))
const _6fe47b2d = () => interopDefault(import('../pages/index/serviceSystem/opportunities-plan/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystem/opportunities-plan/components/studentInfo" */))
const _355206c1 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/chooseSpeciality.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/chooseSpeciality" */))
const _eb52b812 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/fieldConfig.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/fieldConfig" */))
const _1f17079d = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/newPlanByLastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/newPlanByLastStep" */))
const _5e9cfe63 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/components/preview.vue' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/components/preview" */))
const _121280c0 = () => interopDefault(import('../pages/index/serviceSystem/professionalGroup/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/professionalGroup/utils/utils" */))
const _d032ed9e = () => interopDefault(import('../pages/index/serviceSystem/professionNew/components/newPlanByLastStep.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/components/newPlanByLastStep" */))
const _3181a8f7 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/components/preview.vue' /* webpackChunkName: "pages/index/serviceSystem/professionNew/components/preview" */))
const _50c4ff54 = () => interopDefault(import('../pages/index/serviceSystem/professionNew/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystem/professionNew/utils/utils" */))
const _32ba8e89 = () => interopDefault(import('../pages/index/serviceSystem/serviceConditions/components/addConfig.vue' /* webpackChunkName: "pages/index/serviceSystem/serviceConditions/components/addConfig" */))
const _e2369b26 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/downloadPDF" */))
const _2e009bd4 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/leave-message" */))
const _13733377 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/newPlan-by-lastStep" */))
const _0e2e7d19 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/scheme-inspect" */))
const _f1abfda8 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/studentInfo" */))
const _6da2c255 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/components/visable-field-config" */))
const _22392070 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/utils/utils" */))
const _292470c4 = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/components/SmartReport.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/components/SmartReport" */))
const _9ab3efca = () => interopDefault(import('../pages/index/serviceSystemArt/new-regulation/downloadPDF/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-regulation/downloadPDF/downloadPDF" */))
const _3db793fe = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/design-thought.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/design-thought" */))
const _5d032dca = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/leave-message" */))
const _947c1626 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/newPlan-by-lastStep.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/newPlan-by-lastStep" */))
const _8103ac3a = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/scheme-inspect.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/scheme-inspect" */))
const _5e7498a2 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/studentInfo" */))
const _152c2f9f = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/components/visable-field-config.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/components/visable-field-config" */))
const _e125ef84 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/utils/utils.js' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/utils/utils" */))
const _49906104 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/leave-message.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/leave-message" */))
const _72b3e59d = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/scheme-preview" */))
const _a56d5b48 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/components/studentInfo.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/components/studentInfo" */))
const _ceccb8ba = () => interopDefault(import('../pages/index/stationNotification/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/components/edit" */))
const _29a589f4 = () => interopDefault(import('../pages/index/stationNotification/myReceived/components/readView.vue' /* webpackChunkName: "pages/index/stationNotification/myReceived/components/readView" */))
const _447b035d = () => interopDefault(import('../pages/index/stationNotification/myRelease/components/edit.vue' /* webpackChunkName: "pages/index/stationNotification/myRelease/components/edit" */))
const _b7a36fe6 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCardManage/components/soldRecords.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCardManage/components/soldRecords" */))
const _587151e9 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/customerDetail.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/customerDetail" */))
const _2c340f62 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/orderList.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/orderList" */))
const _7bdc4605 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/province.js' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/province" */))
const _04b81c8d = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentCustomer/components/viewInfo.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentCustomer/components/viewInfo" */))
const _5e8bef09 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentList/components/hairpin.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentList/components/hairpin" */))
const _6776adeb = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/card-list.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/card-list" */))
const _060a87f7 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/dictConfig.js' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/dictConfig" */))
const _1af21def = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/orderDetail.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/orderDetail" */))
const _3b0a1d88 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit/components/orderList.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit/components/orderList" */))
const _eaaa7176 = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/components/witchdraw.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/components/witchdraw" */))
const _cbce5b8e = () => interopDefault(import('../pages/index/IPADManage/agentManage/agentProfit2/components/witchdrawOrder.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/agentProfit2/components/witchdrawOrder" */))
const _acceb520 = () => interopDefault(import('../pages/index/IPADManage/agentManage/cardUsageRecord/components/editTime.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/cardUsageRecord/components/editTime" */))
const _74616073 = () => interopDefault(import('../pages/index/IPADManage/agentManage/revenueBreakdownQuery/components/table-expand.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/revenueBreakdownQuery/components/table-expand" */))
const _ed25c00c = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/cardView.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/cardView" */))
const _04d32f4e = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/convertCard.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/convertCard" */))
const _48047f92 = () => interopDefault(import('../pages/index/IPADManage/agentManage/searchCard/components/invalidCard.vue' /* webpackChunkName: "pages/index/IPADManage/agentManage/searchCard/components/invalidCard" */))
const _f24319b0 = () => interopDefault(import('../pages/index/noticeOnline/components/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/noticeOnline/components/myReceived/components/edit" */))
const _4cb1b662 = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/components/edit.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/components/edit" */))
const _38769520 = () => interopDefault(import('../pages/index/noticeOnline/components/mySend/components/readView.vue' /* webpackChunkName: "pages/index/noticeOnline/components/mySend/components/readView" */))
const _7b24c6d7 = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/components/choose-of-profession" */))
const _247c353b = () => interopDefault(import('../pages/index/serviceSystem/general-province/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/estimate-plan/components/scheme-preview" */))
const _7a13e6da = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/components/choose-of-profession" */))
const _45991012 = () => interopDefault(import('../pages/index/serviceSystem/general-province/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/final-plan/components/scheme-preview" */))
const _54d06545 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/components/choose-of-profession" */))
const _1522be29 = () => interopDefault(import('../pages/index/serviceSystem/general-province/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/initial-plan/components/scheme-preview" */))
const _25f78feb = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/components/choose-of-profession" */))
const _45fc94cc = () => interopDefault(import('../pages/index/serviceSystem/general-province/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystem/general-province/smart-report/components/scheme-detail" */))
const _fc1344ba = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/choose-of-profession" */))
const _4c5f471a = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/downloadPDF" */))
const _9a6c55f2 = () => interopDefault(import('../pages/index/serviceSystem/new-version/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/estimate-plan/components/scheme-preview" */))
const _83a66d72 = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/components/choose-of-profession" */))
const _4492cbab = () => interopDefault(import('../pages/index/serviceSystem/new-version/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/final-plan/components/scheme-preview" */))
const _5d4ac4f9 = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/components/choose-of-profession" */))
const _21fbf4dd = () => interopDefault(import('../pages/index/serviceSystem/new-version/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/initial-plan/components/scheme-preview" */))
const _2e71ef9f = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/components/choose-of-profession" */))
const _618cd866 = () => interopDefault(import('../pages/index/serviceSystem/new-version/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystem/new-version/smart-report/components/scheme-detail" */))
const _46899308 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/components/choose-of-profession" */))
const _44938ba8 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/estimate-plan/components/scheme-preview" */))
const _6c89d3fc = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/components/choose-of-profession" */))
const _0dc7feb4 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/final-plan/components/scheme-preview" */))
const _830e6218 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/components/choose-of-profession" */))
const _4de851d0 = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/initial-plan/components/scheme-preview" */))
const _e0c00ccc = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/components/choose-of-profession" */))
const _3e2a42cb = () => interopDefault(import('../pages/index/serviceSystemArt/general-province/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystemArt/general-province/smart-report/components/scheme-detail" */))
const _2006125c = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/choose-of-profession" */))
const _9a1a3b38 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/downloadPDF.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/downloadPDF" */))
const _296a8514 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/estimate-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/estimate-plan/components/scheme-preview" */))
const _1f555678 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/components/choose-of-profession" */))
const _1db5519c = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/final-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/final-plan/components/scheme-preview" */))
const _1684c9ea = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/components/choose-of-profession" */))
const _3c94c28e = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/initial-plan/components/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/initial-plan/components/scheme-preview" */))
const _30a816e0 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/components/choose-of-profession.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/components/choose-of-profession" */))
const _a689ded6 = () => interopDefault(import('../pages/index/serviceSystemArt/new-version/smart-report/components/scheme-detail.vue' /* webpackChunkName: "pages/index/serviceSystemArt/new-version/smart-report/components/scheme-detail" */))
const _7bb518fb = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan" */))
const _7de85949 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview" */))
const _759adf79 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan" */))
const _192dfd28 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection" */))
const _3d371b14 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer" */))
const _449f1f92 = () => interopDefault(import('../pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan.vue' /* webpackChunkName: "pages/index/serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan" */))
const _44c5abc5 = () => interopDefault(import('../pages/index/notice/components/stationNotification/myReceived/components/edit.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myReceived/components/edit" */))
const _187c6efb = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/components/edit.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/components/edit" */))
const _1a02e94c = () => interopDefault(import('../pages/index/notice/components/stationNotification/myRelease/components/readView.vue' /* webpackChunkName: "pages/index/notice/components/stationNotification/myRelease/components/readView" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _2b62405a,
    name: "404"
  }, {
    path: "/im",
    component: _2b8b4159,
    name: "im"
  }, {
    path: "/Login",
    component: _12349eb8,
    name: "Login"
  }, {
    path: "/not-permission",
    component: _3fe5cb3e,
    name: "not-permission"
  }, {
    path: "/",
    component: _946824a6,
    name: "index",
    children: [{
      path: "account",
      component: _85d7de6a,
      name: "index-account"
    }, {
      path: "accountRecord",
      component: _fcd86002,
      name: "index-accountRecord"
    }, {
      path: "approval",
      component: _27ce2058,
      name: "index-approval"
    }, {
      path: "certificateManagement",
      component: _20c1c14a,
      name: "index-certificateManagement"
    }, {
      path: "certificatePersonnel",
      component: _e717a444,
      name: "index-certificatePersonnel"
    }, {
      path: "dictionary",
      component: _c0104f2a,
      name: "index-dictionary"
    }, {
      path: "educational",
      component: _505ce834,
      name: "index-educational"
    }, {
      path: "enrolmentChannel",
      component: _1b5e22d8,
      name: "index-enrolmentChannel"
    }, {
      path: "feedback",
      component: _5d927b1a,
      name: "index-feedback"
    }, {
      path: "groupqrcode",
      component: _a0da26a4,
      name: "index-groupqrcode"
    }, {
      path: "hmtservice",
      component: _27397f9b,
      name: "index-hmtservice"
    }, {
      path: "index",
      component: _e76e9e1a,
      name: "index-index"
    }, {
      path: "manageDeposit",
      component: _7a0762da,
      name: "index-manageDeposit"
    }, {
      path: "manageDepositReturn",
      component: _005dc62c,
      name: "index-manageDepositReturn"
    }, {
      path: "manageDepositX",
      component: _1ef75594,
      name: "index-manageDepositX"
    }, {
      path: "manageMargin",
      component: _4f92c088,
      name: "index-manageMargin"
    }, {
      path: "manageMarginReturn",
      component: _4dc1ffd0,
      name: "index-manageMarginReturn"
    }, {
      path: "manageMarginX",
      component: _0a50a4b4,
      name: "index-manageMarginX"
    }, {
      path: "manageService",
      component: _47d7bb9e,
      name: "index-manageService"
    }, {
      path: "manualReconciliation",
      component: _22f297de,
      name: "index-manualReconciliation"
    }, {
      path: "notice",
      component: _46f07da6,
      name: "index-notice"
    }, {
      path: "noticeOnline",
      component: _1ed5da60,
      name: "index-noticeOnline"
    }, {
      path: "policyForH5",
      component: _27e0c2f6,
      name: "index-policyForH5"
    }, {
      path: "product",
      component: _26c4cb50,
      name: "index-product"
    }, {
      path: "reconcilation",
      component: _d2d4a702,
      name: "index-reconcilation"
    }, {
      path: "selfService",
      component: _0498c4aa,
      name: "index-selfService"
    }, {
      path: "workflow",
      component: _cd1c3258,
      name: "index-workflow"
    }, {
      path: "aiReporting/aiOrder",
      component: _f6e79484,
      name: "index-aiReporting-aiOrder"
    }, {
      path: "aiReporting/appletProduct",
      component: _2d1ddc6d,
      name: "index-aiReporting-appletProduct"
    }, {
      path: "aiReporting/appletProductShare",
      component: _786b7208,
      name: "index-aiReporting-appletProductShare"
    }, {
      path: "aiReporting/baseDataManager",
      component: _308c8eca,
      name: "index-aiReporting-baseDataManager"
    }, {
      path: "aiReporting/creditCards",
      component: _b65aa3bc,
      name: "index-aiReporting-creditCards"
    }, {
      path: "aiReporting/feedbackStatistics",
      component: _78cb3566,
      name: "index-aiReporting-feedbackStatistics"
    }, {
      path: "aiReporting/gptfeedback",
      component: _157aafe8,
      name: "index-aiReporting-gptfeedback"
    }, {
      path: "aiReporting/headQuarters",
      component: _5438cfa5,
      name: "index-aiReporting-headQuarters"
    }, {
      path: "aiReporting/policy",
      component: _188cc410,
      name: "index-aiReporting-policy"
    }, {
      path: "aiReporting/policyInterpretation",
      component: _1ba74f78,
      name: "index-aiReporting-policyInterpretation"
    }, {
      path: "aiReporting/redemptionCode",
      component: _310d7b16,
      name: "index-aiReporting-redemptionCode"
    }, {
      path: "aiReporting/timeAxis",
      component: _1c1b372c,
      name: "index-aiReporting-timeAxis"
    }, {
      path: "artExamination/academic",
      component: _073a3789,
      name: "index-artExamination-academic"
    }, {
      path: "artExamination/checkAndUpload",
      component: _6dddc492,
      name: "index-artExamination-checkAndUpload"
    }, {
      path: "artExamination/onePointOneLevelArt",
      component: _e883d322,
      name: "index-artExamination-onePointOneLevelArt"
    }, {
      path: "artExamination/policy",
      component: _6c3a03b4,
      name: "index-artExamination-policy"
    }, {
      path: "artExamination/specialtyScore",
      component: _ceda3594,
      name: "index-artExamination-specialtyScore"
    }, {
      path: "artExamination/university",
      component: _173bfa90,
      name: "index-artExamination-university"
    }, {
      path: "company/course",
      component: _417a2802,
      name: "index-company-course"
    }, {
      path: "company/courseclassif",
      component: _2d3666a9,
      name: "index-company-courseclassif"
    }, {
      path: "company/courselearning",
      component: _8c3012c0,
      name: "index-company-courselearning"
    }, {
      path: "company/CourseLearningProgress",
      component: _6ef4a826,
      name: "index-company-CourseLearningProgress"
    }, {
      path: "company/feedback",
      component: _ccb3f828,
      name: "index-company-feedback"
    }, {
      path: "company/studyNotes",
      component: _e46dcfc2,
      name: "index-company-studyNotes"
    }, {
      path: "comprehensive/application",
      component: _299a0b76,
      name: "index-comprehensive-application"
    }, {
      path: "comprehensive/coverLetter",
      component: _0cba60a3,
      name: "index-comprehensive-coverLetter"
    }, {
      path: "comprehensive/matchIntroduce",
      component: _317eb88a,
      name: "index-comprehensive-matchIntroduce"
    }, {
      path: "comprehensive/qualitySpecialityInfo",
      component: _1dc99868,
      name: "index-comprehensive-qualitySpecialityInfo"
    }, {
      path: "comprehensive/universityManage",
      component: _72b06e7a,
      name: "index-comprehensive-universityManage"
    }, {
      path: "comprehensive/videoManagement",
      component: _7e1e6a44,
      name: "index-comprehensive-videoManagement"
    }, {
      path: "customer/assignStudent",
      component: _4176b470,
      name: "index-customer-assignStudent"
    }, {
      path: "customer/customer",
      component: _aba4ec60,
      name: "index-customer-customer"
    }, {
      path: "customer/livingCustomer",
      component: _220099ce,
      name: "index-customer-livingCustomer"
    }, {
      path: "customer/student",
      component: _38c6545f,
      name: "index-customer-student"
    }, {
      path: "customer/zonghe",
      component: _5376b49d,
      name: "index-customer-zonghe"
    }, {
      path: "customerStatistics/customerInfo",
      component: _d84c680a,
      name: "index-customerStatistics-customerInfo"
    }, {
      path: "customerStatistics/statistics",
      component: _696e97b2,
      name: "index-customerStatistics-statistics"
    }, {
      path: "dailyWeekly/weekly",
      component: _68628588,
      name: "index-dailyWeekly-weekly"
    }, {
      path: "dailyWork/dailySpeech",
      component: _60d855b7,
      name: "index-dailyWork-dailySpeech"
    }, {
      path: "dailyWork/importWeek",
      component: _2a1654f3,
      name: "index-dailyWork-importWeek"
    }, {
      path: "dailyWork/monthList",
      component: _1d654d1a,
      name: "index-dailyWork-monthList"
    }, {
      path: "dailyWork/weekList",
      component: _3f170a28,
      name: "index-dailyWork-weekList"
    }, {
      path: "dailyWork/weekTemplate",
      component: _ea1a3b70,
      name: "index-dailyWork-weekTemplate"
    }, {
      path: "dailyWork/yearList",
      component: _5850af75,
      name: "index-dailyWork-yearList"
    }, {
      path: "examination/analysis",
      component: _24aa098f,
      name: "index-examination-analysis"
    }, {
      path: "examination/bank",
      component: _c5ff9e22,
      name: "index-examination-bank"
    }, {
      path: "examination/exam",
      component: _76232312,
      name: "index-examination-exam"
    }, {
      path: "examination/myPlan",
      component: _05456868,
      name: "index-examination-myPlan"
    }, {
      path: "examination/paper",
      component: _132e6e0f,
      name: "index-examination-paper"
    }, {
      path: "examination/plan",
      component: _dd299cc8,
      name: "index-examination-plan"
    }, {
      path: "examination/result",
      component: _7de68790,
      name: "index-examination-result"
    }, {
      path: "feedback/edit",
      component: _6c40dcf2,
      name: "index-feedback-edit"
    }, {
      path: "feedback/reply",
      component: _73da9932,
      name: "index-feedback-reply"
    }, {
      path: "generalService/baseDataManagement",
      component: _78dfe301,
      name: "index-generalService-baseDataManagement"
    }, {
      path: "generalService/cityImports",
      component: _d790b594,
      name: "index-generalService-cityImports"
    }, {
      path: "generalService/disciplineCategoryManagement",
      component: _3b562bf4,
      name: "index-generalService-disciplineCategoryManagement"
    }, {
      path: "generalService/hotSpot",
      component: _8f41a8bc,
      name: "index-generalService-hotSpot"
    }, {
      path: "generalService/onePointOneLevel",
      component: _4345d56b,
      name: "index-generalService-onePointOneLevel"
    }, {
      path: "generalService/referenceScoreCalculate",
      component: _b55afc5c,
      name: "index-generalService-referenceScoreCalculate"
    }, {
      path: "generalService/relativeManagement",
      component: _1ec90132,
      name: "index-generalService-relativeManagement"
    }, {
      path: "generalService/subjectAssessDataManagement",
      component: _05583e90,
      name: "index-generalService-subjectAssessDataManagement"
    }, {
      path: "generalService/supplementaryBaseScore",
      component: _5f67dd35,
      name: "index-generalService-supplementaryBaseScore"
    }, {
      path: "generalService/trainingRecord",
      component: _3af7d7ce,
      name: "index-generalService-trainingRecord"
    }, {
      path: "generalService/urbanCompetitiveness",
      component: _312b0f77,
      name: "index-generalService-urbanCompetitiveness"
    }, {
      path: "generalService/versionManagement",
      component: _a3324224,
      name: "index-generalService-versionManagement"
    }, {
      path: "hmtservice/englishVideo",
      component: _180c27b5,
      name: "index-hmtservice-englishVideo",
      children: [{
        path: "academyIntroduction",
        component: _00b6784c,
        name: "index-hmtservice-englishVideo-index-academyIntroduction"
      }, {
        path: "academyIntroduction_unreleased",
        component: _6d436659,
        name: "index-hmtservice-englishVideo-index-academyIntroduction_unreleased"
      }, {
        path: "oralLanguage",
        component: _d81fcae0,
        name: "index-hmtservice-englishVideo-index-oralLanguage"
      }]
    }, {
      path: "hmtservice/index_unreleased",
      component: _623807aa,
      name: "index-hmtservice-index_unreleased"
    }, {
      path: "hmtservice/scheme",
      component: _7b89d6ac,
      name: "index-hmtservice-scheme"
    }, {
      path: "hmtservice/scheme_unreleased",
      component: _1de74bf9,
      name: "index-hmtservice-scheme_unreleased"
    }, {
      path: "information/ArtScore",
      component: _3a48d032,
      name: "index-information-ArtScore"
    }, {
      path: "information/batch",
      component: _77dcbd78,
      name: "index-information-batch"
    }, {
      path: "information/hmkColleges",
      component: _4a8411e0,
      name: "index-information-hmkColleges"
    }, {
      path: "information/newsList",
      component: _171bcd69,
      name: "index-information-newsList"
    }, {
      path: "information/onePointOneLevel",
      component: _5aa06f40,
      name: "index-information-onePointOneLevel"
    }, {
      path: "information/Score",
      component: _03e88eb0,
      name: "index-information-Score"
    }, {
      path: "information/speciality",
      component: _c7b0ff26,
      name: "index-information-speciality"
    }, {
      path: "information/specialityinfoElective",
      component: _39acec64,
      name: "index-information-specialityinfoElective"
    }, {
      path: "information/studentList",
      component: _77622292,
      name: "index-information-studentList"
    }, {
      path: "information/subjectAssessment",
      component: _4b959c68,
      name: "index-information-subjectAssessment"
    }, {
      path: "information/taiwanColleges",
      component: _2667d57c,
      name: "index-information-taiwanColleges"
    }, {
      path: "information/university",
      component: _7d548666,
      name: "index-information-university"
    }, {
      path: "IPADManage/agentProduce",
      component: _657401fc,
      name: "index-IPADManage-agentProduce"
    }, {
      path: "IPADManage/campus-banner",
      component: _3be2b6a2,
      name: "index-IPADManage-campus-banner"
    }, {
      path: "IPADManage/campus-information",
      component: _5036b0df,
      name: "index-IPADManage-campus-information"
    }, {
      path: "IPADManage/caseClassification",
      component: _c1dcb652,
      name: "index-IPADManage-caseClassification"
    }, {
      path: "IPADManage/classicCases",
      component: _3b510232,
      name: "index-IPADManage-classicCases"
    }, {
      path: "IPADManage/corporateCulture-banner",
      component: _13b1a0c5,
      name: "index-IPADManage-corporateCulture-banner"
    }, {
      path: "IPADManage/corporateCulture-Images",
      component: _4c6f8d9e,
      name: "index-IPADManage-corporateCulture-Images"
    }, {
      path: "IPADManage/IndexConfiguration",
      component: _5ec9b985,
      name: "index-IPADManage-IndexConfiguration"
    }, {
      path: "IPADManage/produce",
      component: _3114fc96,
      name: "index-IPADManage-produce"
    }, {
      path: "lecturerApplication/application",
      component: _1ae8fc9e,
      name: "index-lecturerApplication-application"
    }, {
      path: "lecturerApplication/applicationReport",
      component: _2c7436b2,
      name: "index-lecturerApplication-applicationReport"
    }, {
      path: "log/loginLog",
      component: _383b3258,
      name: "index-log-loginLog"
    }, {
      path: "log/operLog",
      component: _493aaa2e,
      name: "index-log-operLog"
    }, {
      path: "manageDepositX/orderListModal",
      component: _b545f9a2,
      name: "index-manageDepositX-orderListModal"
    }, {
      path: "manageMarginX/orderListModal",
      component: _dcecc146,
      name: "index-manageMarginX-orderListModal"
    }, {
      path: "monthly/monthly",
      component: _303afcae,
      name: "index-monthly-monthly"
    }, {
      path: "myToolBox/answers",
      component: _47419d8e,
      name: "index-myToolBox-answers"
    }, {
      path: "myToolBox/carryForward",
      component: _6c9cfb72,
      name: "index-myToolBox-carryForward"
    }, {
      path: "myToolBox/informationPackage",
      component: _76e28517,
      name: "index-myToolBox-informationPackage"
    }, {
      path: "myToolBox/libraryManage",
      component: _67fc02d9,
      name: "index-myToolBox-libraryManage"
    }, {
      path: "myToolBox/mailList",
      component: _42da2b52,
      name: "index-myToolBox-mailList"
    }, {
      path: "myToolBox/mailListManage",
      component: _8011e552,
      name: "index-myToolBox-mailListManage"
    }, {
      path: "myToolBox/product",
      component: _6645e188,
      name: "index-myToolBox-product"
    }, {
      path: "myToolBox/video",
      component: _61cf2194,
      name: "index-myToolBox-video"
    }, {
      path: "opportunityPoint/opportunity",
      component: _91bc2454,
      name: "index-opportunityPoint-opportunity"
    }, {
      path: "order/failOrders",
      component: _bc40704e,
      name: "index-order-failOrders"
    }, {
      path: "order/onlineOrders",
      component: _32ccd24e,
      name: "index-order-onlineOrders"
    }, {
      path: "order/onlineRefund",
      component: _1b1cf321,
      name: "index-order-onlineRefund"
    }, {
      path: "order/pos",
      component: _37e19018,
      name: "index-order-pos"
    }, {
      path: "order/productChange",
      component: _3148071f,
      name: "index-order-productChange"
    }, {
      path: "order/refund",
      component: _d1432224,
      name: "index-order-refund"
    }, {
      path: "order/sales",
      component: _656cfb6c,
      name: "index-order-sales"
    }, {
      path: "order/touristOrders",
      component: _3398d457,
      name: "index-order-touristOrders"
    }, {
      path: "padManage/campus",
      component: _0309e74b,
      name: "index-padManage-campus"
    }, {
      path: "padManage/group",
      component: _14ffb2ae,
      name: "index-padManage-group"
    }, {
      path: "padManage/inventory",
      component: _02fa99c6,
      name: "index-padManage-inventory"
    }, {
      path: "product/offline",
      component: _08a49824,
      name: "index-product-offline"
    }, {
      path: "product/stock",
      component: _c23541d2,
      name: "index-product-stock"
    }, {
      path: "quickReferenceTable/add",
      component: _5696f8c0,
      name: "index-quickReferenceTable-add"
    }, {
      path: "quickReferenceTable/quickReferenceTable",
      component: _61fd15a2,
      name: "index-quickReferenceTable-quickReferenceTable"
    }, {
      path: "report/achievement",
      component: _9f904db4,
      name: "index-report-achievement"
    }, {
      path: "report/campusPerformanceSummary",
      component: _73139031,
      name: "index-report-campusPerformanceSummary"
    }, {
      path: "report/customerStatisticsReport",
      component: _059c8064,
      name: "index-report-customerStatisticsReport"
    }, {
      path: "report/education",
      component: _15e7f8df,
      name: "index-report-education"
    }, {
      path: "report/expendReport",
      component: _46633f0b,
      name: "index-report-expendReport"
    }, {
      path: "report/headquarters",
      component: _75d27d40,
      name: "index-report-headquarters"
    }, {
      path: "report/intenReport",
      component: _742427a3,
      name: "index-report-intenReport"
    }, {
      path: "report/lecturerPerformanceRankingTable",
      component: _73e7cc6e,
      name: "index-report-lecturerPerformanceRankingTable"
    }, {
      path: "report/operationalPerformanceRankingTable",
      component: _21ed0272,
      name: "index-report-operationalPerformanceRankingTable"
    }, {
      path: "report/operationsManagerPerformanceReport",
      component: _3b18f382,
      name: "index-report-operationsManagerPerformanceReport"
    }, {
      path: "report/orderListModal",
      component: _62791fda,
      name: "index-report-orderListModal"
    }, {
      path: "report/performanceReport",
      component: _84e4a004,
      name: "index-report-performanceReport"
    }, {
      path: "report/performanceReportJoin",
      component: _3d137970,
      name: "index-report-performanceReportJoin"
    }, {
      path: "report/productLineTransfer",
      component: _5403fe05,
      name: "index-report-productLineTransfer"
    }, {
      path: "report/proIntenReport",
      component: _0c1421d0,
      name: "index-report-proIntenReport"
    }, {
      path: "report/salesSummaryB2C",
      component: _c46edf60,
      name: "index-report-salesSummaryB2C"
    }, {
      path: "report/serviceNumberReport",
      component: _71e5b6a9,
      name: "index-report-serviceNumberReport"
    }, {
      path: "report/serviceProgressReport",
      component: _592df38d,
      name: "index-report-serviceProgressReport"
    }, {
      path: "report/serviceReport",
      component: _ea814500,
      name: "index-report-serviceReport"
    }, {
      path: "report/serviceStepReport",
      component: _6cff376c,
      name: "index-report-serviceStepReport"
    }, {
      path: "report/teacherAchievementReport",
      component: _fe00e9cc,
      name: "index-report-teacherAchievementReport"
    }, {
      path: "report/variousRegionsReport",
      component: _7e6de081,
      name: "index-report-variousRegionsReport"
    }, {
      path: "revenues/paymentRecord",
      component: _26d1ef54,
      name: "index-revenues-paymentRecord"
    }, {
      path: "revenues/refundRecord",
      component: _fd776afc,
      name: "index-revenues-refundRecord"
    }, {
      path: "revenues/transferRecord",
      component: _2179a575,
      name: "index-revenues-transferRecord"
    }, {
      path: "selfService/planStore",
      component: _04882293,
      name: "index-selfService-planStore"
    }, {
      path: "selfService/programme",
      component: _0e43bd12,
      name: "index-selfService-programme"
    }, {
      path: "serviceSystem/career",
      component: _da6a5384,
      name: "index-serviceSystem-career"
    }, {
      path: "serviceSystem/entrancePlanningMap",
      component: _47753aff,
      name: "index-serviceSystem-entrancePlanningMap"
    }, {
      path: "serviceSystem/learnMethods",
      component: _41280864,
      name: "index-serviceSystem-learnMethods"
    }, {
      path: "serviceSystem/learnStatus",
      component: _496e3cec,
      name: "index-serviceSystem-learnStatus"
    }, {
      path: "serviceSystem/opportunities-plan",
      component: _73bd7745,
      name: "index-serviceSystem-opportunities-plan"
    }, {
      path: "serviceSystem/serviceConditions",
      component: _350dbfe3,
      name: "index-serviceSystem-serviceConditions"
    }, {
      path: "serviceSystem/volunteer",
      component: _729efa40,
      name: "index-serviceSystem-volunteer"
    }, {
      path: "serviceSystemArt/opportunities-plan",
      component: _7eff8036,
      name: "index-serviceSystemArt-opportunities-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan-xk",
      component: _79505400,
      name: "index-serviceSystemArt-opportunities-plan-xk"
    }, {
      path: "stationNotification/myReceived",
      component: _0f839592,
      name: "index-stationNotification-myReceived"
    }, {
      path: "stationNotification/myRelease",
      component: _55a71468,
      name: "index-stationNotification-myRelease"
    }, {
      path: "stationNotification/taskSituation",
      component: _5046268a,
      name: "index-stationNotification-taskSituation"
    }, {
      path: "system/configs",
      component: _04caf2a6,
      name: "index-system-configs"
    }, {
      path: "system/menu",
      component: _aded3ec0,
      name: "index-system-menu"
    }, {
      path: "system/org",
      component: _19ba8559,
      name: "index-system-org"
    }, {
      path: "system/role",
      component: _05ce1af7,
      name: "index-system-role"
    }, {
      path: "test/crud",
      component: _a7f62e8e,
      name: "index-test-crud"
    }, {
      path: "weekly/weekly",
      component: _1d083226,
      name: "index-weekly-weekly"
    }, {
      path: "workbench/approvalDealtService",
      component: _877d84dc,
      name: "index-workbench-approvalDealtService"
    }, {
      path: "workbench/eduDealtService",
      component: _17b9f8b1,
      name: "index-workbench-eduDealtService"
    }, {
      path: "workbench/finishedService",
      component: _380e93b1,
      name: "index-workbench-finishedService"
    }, {
      path: "workbench/handleDone",
      component: _1b268a6f,
      name: "index-workbench-handleDone"
    }, {
      path: "workbench/myToDo",
      component: _2673bbd7,
      name: "index-workbench-myToDo"
    }, {
      path: "workbench/notice",
      component: _34f567fa,
      name: "index-workbench-notice"
    }, {
      path: "workbench/noticeAdmin",
      component: _22f3ee25,
      name: "index-workbench-noticeAdmin"
    }, {
      path: "workbench/salesDealtService",
      component: _606ff887,
      name: "index-workbench-salesDealtService"
    }, {
      path: "workbench/serviceDealtService",
      component: _61810eb0,
      name: "index-workbench-serviceDealtService"
    }, {
      path: "artExamination/university/orderListModal",
      component: _3e5c39b3,
      name: "index-artExamination-university-orderListModal"
    }, {
      path: "artExamination/university/orderListModalEdit",
      component: _66ecf15d,
      name: "index-artExamination-university-orderListModalEdit"
    }, {
      path: "customer/livingCustomer/customerListModal",
      component: _65c1bab8,
      name: "index-customer-livingCustomer-customerListModal"
    }, {
      path: "customer/zonghe/honourPreviewModal",
      component: _fcb4bf62,
      name: "index-customer-zonghe-honourPreviewModal"
    }, {
      path: "customer/zonghe/newPassPreviewModal",
      component: _157efcc1,
      name: "index-customer-zonghe-newPassPreviewModal"
    }, {
      path: "customer/zonghe/oldPassPreviewModal",
      component: _1dfe77c8,
      name: "index-customer-zonghe-oldPassPreviewModal"
    }, {
      path: "customer/zonghe/practicePreviewModal",
      component: _09a446b6,
      name: "index-customer-zonghe-practicePreviewModal"
    }, {
      path: "examination/analysis/viewInfo",
      component: _e0d87674,
      name: "index-examination-analysis-viewInfo"
    }, {
      path: "generalService/hotSpot/hotSpotModal",
      component: _3042205e,
      name: "index-generalService-hotSpot-hotSpotModal"
    }, {
      path: "hmtservice/application/addApplication",
      component: _74259f95,
      name: "index-hmtservice-application-addApplication"
    }, {
      path: "hmtservice/application/application",
      component: _51fa841a,
      name: "index-hmtservice-application-application"
    }, {
      path: "hmtservice/application/backMaterials",
      component: _7c6b46cf,
      name: "index-hmtservice-application-backMaterials"
    }, {
      path: "hmtservice/application/materials",
      component: _25125576,
      name: "index-hmtservice-application-materials"
    }, {
      path: "hmtservice/application/pushMaterials",
      component: _7d38077c,
      name: "index-hmtservice-application-pushMaterials"
    }, {
      path: "hmtservice/coverLetter/coverLetter",
      component: _1dde7e74,
      name: "index-hmtservice-coverLetter-coverLetter"
    }, {
      path: "hmtservice/coverLetter/guidance",
      component: _f1ec0a9e,
      name: "index-hmtservice-coverLetter-guidance"
    }, {
      path: "hmtservice/coverLetter/upLoad",
      component: _b2d77d8c,
      name: "index-hmtservice-coverLetter-upLoad"
    }, {
      path: "hmtservice/coverLetter/upSignup",
      component: _7fe9456c,
      name: "index-hmtservice-coverLetter-upSignup"
    }, {
      path: "hmtservice/coverLetter/upSignUpNew",
      component: _2241d0a4,
      name: "index-hmtservice-coverLetter-upSignUpNew"
    }, {
      path: "hmtservice/englishVideo/index_unreleased",
      component: _76b72b50,
      name: "index-hmtservice-englishVideo-index_unreleased"
    }, {
      path: "hmtservice/interviwe/addAdmissionModel",
      component: _76b16738,
      name: "index-hmtservice-interviwe-addAdmissionModel"
    }, {
      path: "hmtservice/interviwe/addTrainModel",
      component: _3a7d47ce,
      name: "index-hmtservice-interviwe-addTrainModel"
    }, {
      path: "hmtservice/interviwe/admission",
      component: _316f5ac0,
      name: "index-hmtservice-interviwe-admission"
    }, {
      path: "hmtservice/interviwe/admissionStatus",
      component: _10348fb2,
      name: "index-hmtservice-interviwe-admissionStatus"
    }, {
      path: "hmtservice/interviwe/materials",
      component: _695df986,
      name: "index-hmtservice-interviwe-materials"
    }, {
      path: "hmtservice/interviwe/trainManage",
      component: _ee36eb38,
      name: "index-hmtservice-interviwe-trainManage"
    }, {
      path: "hmtservice/interviwe/trainPlan",
      component: _79b003e8,
      name: "index-hmtservice-interviwe-trainPlan"
    }, {
      path: "hmtservice/interviwe/video",
      component: _2b536e95,
      name: "index-hmtservice-interviwe-video"
    }, {
      path: "hmtservice/plan/HM",
      component: _66f8abb4,
      name: "index-hmtservice-plan-HM"
    }, {
      path: "hmtservice/plan/T",
      component: _6f493f75,
      name: "index-hmtservice-plan-T"
    }, {
      path: "IPADManage/agentManage/agentCardManage",
      component: _325d9fca,
      name: "index-IPADManage-agentManage-agentCardManage"
    }, {
      path: "IPADManage/agentManage/agentCustomer",
      component: _4864a35a,
      name: "index-IPADManage-agentManage-agentCustomer"
    }, {
      path: "IPADManage/agentManage/agentInformation",
      component: _9a5d2ba6,
      name: "index-IPADManage-agentManage-agentInformation"
    }, {
      path: "IPADManage/agentManage/agentList",
      component: _1b516c13,
      name: "index-IPADManage-agentManage-agentList"
    }, {
      path: "IPADManage/agentManage/agentProfit",
      component: _771e93b9,
      name: "index-IPADManage-agentManage-agentProfit"
    }, {
      path: "IPADManage/agentManage/agentProfit2",
      component: _aa589022,
      name: "index-IPADManage-agentManage-agentProfit2"
    }, {
      path: "IPADManage/agentManage/cardUsageRecord",
      component: _fc41d71c,
      name: "index-IPADManage-agentManage-cardUsageRecord"
    }, {
      path: "IPADManage/agentManage/orgProductOffline",
      component: _88c9f4f0,
      name: "index-IPADManage-agentManage-orgProductOffline"
    }, {
      path: "IPADManage/agentManage/productManage",
      component: _73a60b78,
      name: "index-IPADManage-agentManage-productManage"
    }, {
      path: "IPADManage/agentManage/revenueBreakdownQuery",
      component: _40bf849a,
      name: "index-IPADManage-agentManage-revenueBreakdownQuery"
    }, {
      path: "IPADManage/agentManage/revenueQuery",
      component: _76450e92,
      name: "index-IPADManage-agentManage-revenueQuery"
    }, {
      path: "IPADManage/agentManage/searchCard",
      component: _04456dc4,
      name: "index-IPADManage-agentManage-searchCard"
    }, {
      path: "notice/components/orderNotification",
      component: _c32bf050,
      name: "index-notice-components-orderNotification"
    }, {
      path: "noticeOnline/components/myReceived",
      component: _1cb81757,
      name: "index-noticeOnline-components-myReceived"
    }, {
      path: "noticeOnline/components/mySend",
      component: _4b9c5dbe,
      name: "index-noticeOnline-components-mySend"
    }, {
      path: "opportunityPoint/opportunity/add",
      component: _abbcadb6,
      name: "index-opportunityPoint-opportunity-add"
    }, {
      path: "product/offline/productListModal",
      component: _5f8efdc4,
      name: "index-product-offline-productListModal"
    }, {
      path: "product/stock/addStockDrawer",
      component: _85228c5e,
      name: "index-product-stock-addStockDrawer"
    }, {
      path: "product/stock/addStockDrawerForArt",
      component: _049041ea,
      name: "index-product-stock-addStockDrawerForArt"
    }, {
      path: "product/stock/addStockDrawerForSchoolPartner",
      component: _635ea248,
      name: "index-product-stock-addStockDrawerForSchoolPartner"
    }, {
      path: "product/stock/addStockDrawerForZP",
      component: _226c0dc4,
      name: "index-product-stock-addStockDrawerForZP"
    }, {
      path: "product/stock/addStockDrawerForZPSchoolPartner",
      component: _753aeb34,
      name: "index-product-stock-addStockDrawerForZPSchoolPartner"
    }, {
      path: "product/stock/orderListModal",
      component: _708405e8,
      name: "index-product-stock-orderListModal"
    }, {
      path: "product/stock/RefundStockDrawer",
      component: _744f2534,
      name: "index-product-stock-RefundStockDrawer"
    }, {
      path: "product/stock/selectProductModal",
      component: _489a8425,
      name: "index-product-stock-selectProductModal"
    }, {
      path: "product/stock/stockRefund",
      component: _397eccb3,
      name: "index-product-stock-stockRefund"
    }, {
      path: "reconcilation/components/table-expand",
      component: _51dd343f,
      name: "index-reconcilation-components-table-expand"
    }, {
      path: "selfService/components/DesignThoughtModal",
      component: _3ca5dffa,
      name: "index-selfService-components-DesignThoughtModal"
    }, {
      path: "selfService/components/LeaveMessageModal",
      component: _0637e2bc,
      name: "index-selfService-components-LeaveMessageModal"
    }, {
      path: "selfService/components/seniority",
      component: _633a82c6,
      name: "index-selfService-components-seniority"
    }, {
      path: "selfService/components/studentInfo",
      component: _8209f730,
      name: "index-selfService-components-studentInfo"
    }, {
      path: "selfService/stepFive/confirmationPlan",
      component: _154364a7,
      name: "index-selfService-stepFive-confirmationPlan"
    }, {
      path: "selfService/stepFive/finalSolutionLibrary",
      component: _b555b656,
      name: "index-selfService-stepFive-finalSolutionLibrary"
    }, {
      path: "selfService/stepFive/universityBrochure",
      component: _dc8a9b8a,
      name: "index-selfService-stepFive-universityBrochure"
    }, {
      path: "selfService/stepFour/addApplication",
      component: _62972338,
      name: "index-selfService-stepFour-addApplication"
    }, {
      path: "selfService/stepFour/backMaterials",
      component: _3b203bc0,
      name: "index-selfService-stepFour-backMaterials"
    }, {
      path: "selfService/stepFour/coverLetter",
      component: _82028ad0,
      name: "index-selfService-stepFour-coverLetter"
    }, {
      path: "selfService/stepFour/guideVideo",
      component: _007fddd4,
      name: "index-selfService-stepFour-guideVideo"
    }, {
      path: "selfService/stepFour/materials",
      component: _eff97d72,
      name: "index-selfService-stepFour-materials"
    }, {
      path: "selfService/stepFour/pushMaterials",
      component: _3986ba66,
      name: "index-selfService-stepFour-pushMaterials"
    }, {
      path: "selfService/stepSix/fillinVideo",
      component: _04f1a532,
      name: "index-selfService-stepSix-fillinVideo"
    }, {
      path: "selfService/stepSix/schemeScreenshot",
      component: _3bfba5bc,
      name: "index-selfService-stepSix-schemeScreenshot"
    }, {
      path: "selfService/stepSix/upLoad",
      component: _ac70999c,
      name: "index-selfService-stepSix-upLoad"
    }, {
      path: "selfService/stepThree/planStore",
      component: _6824af36,
      name: "index-selfService-stepThree-planStore"
    }, {
      path: "selfService/stepThree/recruitment",
      component: _962cd84c,
      name: "index-selfService-stepThree-recruitment"
    }, {
      path: "selfService/stepThree/recruitStudent",
      component: _0545eef5,
      name: "index-selfService-stepThree-recruitStudent"
    }, {
      path: "selfService/stepTwo/guideVideo",
      component: _265f1dc6,
      name: "index-selfService-stepTwo-guideVideo"
    }, {
      path: "selfService/stepTwo/match",
      component: _98359ea4,
      name: "index-selfService-stepTwo-match"
    }, {
      path: "selfService/stepTwo/planDesign",
      component: _d5b98da4,
      name: "index-selfService-stepTwo-planDesign"
    }, {
      path: "selfService/stepTwo/seniority",
      component: _61e00332,
      name: "index-selfService-stepTwo-seniority"
    }, {
      path: "selfService/stepTwo/studentPassageway",
      component: _219cd936,
      name: "index-selfService-stepTwo-studentPassageway"
    }, {
      path: "selfService/stepTwo/videoDrawer",
      component: _0138e816,
      name: "index-selfService-stepTwo-videoDrawer"
    }, {
      path: "serviceSystem/commonFile/citySelect",
      component: _16156ee2,
      name: "index-serviceSystem-commonFile-citySelect"
    }, {
      path: "serviceSystem/commonFile/complateServiceModal",
      component: _d23e9cb0,
      name: "index-serviceSystem-commonFile-complateServiceModal"
    }, {
      path: "serviceSystem/commonFile/designThought",
      component: _14143f30,
      name: "index-serviceSystem-commonFile-designThought"
    }, {
      path: "serviceSystem/commonFile/designThoughtForOp",
      component: _7ce9986a,
      name: "index-serviceSystem-commonFile-designThoughtForOp"
    }, {
      path: "serviceSystem/commonFile/designThoughtForSpecal",
      component: _57fbc0af,
      name: "index-serviceSystem-commonFile-designThoughtForSpecal"
    }, {
      path: "serviceSystem/commonFile/exportOption",
      component: _7dd0fc24,
      name: "index-serviceSystem-commonFile-exportOption"
    }, {
      path: "serviceSystem/commonFile/scoreStatisticsListModal",
      component: _12aeecb5,
      name: "index-serviceSystem-commonFile-scoreStatisticsListModal"
    }, {
      path: "serviceSystem/commonFile/serviceStep",
      component: _79605fd4,
      name: "index-serviceSystem-commonFile-serviceStep"
    }, {
      path: "serviceSystem/commonFile/specialityPackage",
      component: _2f839f34,
      name: "index-serviceSystem-commonFile-specialityPackage"
    }, {
      path: "serviceSystem/commonFile/specialityPackageaAdd",
      component: _37091c34,
      name: "index-serviceSystem-commonFile-specialityPackageaAdd"
    }, {
      path: "serviceSystem/commonFile/specialityTreeModal",
      component: _4981474f,
      name: "index-serviceSystem-commonFile-specialityTreeModal"
    }, {
      path: "serviceSystem/commonFile/specialityTreeNew",
      component: _3e70df42,
      name: "index-serviceSystem-commonFile-specialityTreeNew"
    }, {
      path: "serviceSystem/commonFile/specialRequirementsModal",
      component: _e573adc2,
      name: "index-serviceSystem-commonFile-specialRequirementsModal"
    }, {
      path: "serviceSystem/commonFile/studentInfo",
      component: _5d317b04,
      name: "index-serviceSystem-commonFile-studentInfo"
    }, {
      path: "serviceSystem/commonFile/studentInfoDetailModal",
      component: _73a0bdae,
      name: "index-serviceSystem-commonFile-studentInfoDetailModal"
    }, {
      path: "serviceSystem/commonFile/studentList",
      component: _1701166e,
      name: "index-serviceSystem-commonFile-studentList"
    }, {
      path: "serviceSystem/commonFile/studentUpdate",
      component: _72a4e319,
      name: "index-serviceSystem-commonFile-studentUpdate"
    }, {
      path: "serviceSystem/general-province/estimate-plan",
      component: _67294ad4,
      name: "index-serviceSystem-general-province-estimate-plan"
    }, {
      path: "serviceSystem/general-province/final-plan",
      component: _04b84390,
      name: "index-serviceSystem-general-province-final-plan"
    }, {
      path: "serviceSystem/general-province/initial-plan",
      component: _2b6f16c2,
      name: "index-serviceSystem-general-province-initial-plan"
    }, {
      path: "serviceSystem/general-province/scheme",
      component: _0cf0e455,
      name: "index-serviceSystem-general-province-scheme"
    }, {
      path: "serviceSystem/general-province/smart-report",
      component: _548b44e8,
      name: "index-serviceSystem-general-province-smart-report"
    }, {
      path: "serviceSystem/new-version/estimate-plan",
      component: _64b3c8a0,
      name: "index-serviceSystem-new-version-estimate-plan"
    }, {
      path: "serviceSystem/new-version/final-plan",
      component: _1b377944,
      name: "index-serviceSystem-new-version-final-plan"
    }, {
      path: "serviceSystem/new-version/initial-plan",
      component: _c210a114,
      name: "index-serviceSystem-new-version-initial-plan"
    }, {
      path: "serviceSystem/new-version/scheme",
      component: _d391d7ee,
      name: "index-serviceSystem-new-version-scheme"
    }, {
      path: "serviceSystem/new-version/smart-report",
      component: _6fd844c8,
      name: "index-serviceSystem-new-version-smart-report"
    }, {
      path: "serviceSystem/newRegulation/estimate-plan",
      component: _8846d1c8,
      name: "index-serviceSystem-newRegulation-estimate-plan"
    }, {
      path: "serviceSystem/newRegulation/final-plan",
      component: _726206bc,
      name: "index-serviceSystem-newRegulation-final-plan"
    }, {
      path: "serviceSystem/newRegulation/initial-plan",
      component: _48b907d8,
      name: "index-serviceSystem-newRegulation-initial-plan"
    }, {
      path: "serviceSystem/newRegulation/scheme",
      component: _7fd107a7,
      name: "index-serviceSystem-newRegulation-scheme"
    }, {
      path: "serviceSystem/occupations/occupation",
      component: _9648ae1c,
      name: "index-serviceSystem-occupations-occupation"
    }, {
      path: "serviceSystem/occupations/planning",
      component: _01de48f8,
      name: "index-serviceSystem-occupations-planning"
    }, {
      path: "serviceSystem/occupations/report",
      component: _244d8b9b,
      name: "index-serviceSystem-occupations-report"
    }, {
      path: "serviceSystem/occupations/scheme",
      component: _123d52cc,
      name: "index-serviceSystem-occupations-scheme"
    }, {
      path: "serviceSystem/opportunities-plan/scheme",
      component: _6cbda145,
      name: "index-serviceSystem-opportunities-plan-scheme"
    }, {
      path: "serviceSystem/professionalGroup/estimate-plan",
      component: _fe3e0f66,
      name: "index-serviceSystem-professionalGroup-estimate-plan"
    }, {
      path: "serviceSystem/professionalGroup/final-plan",
      component: _2f0f30b7,
      name: "index-serviceSystem-professionalGroup-final-plan"
    }, {
      path: "serviceSystem/professionalGroup/initial-plan",
      component: _1bbf5629,
      name: "index-serviceSystem-professionalGroup-initial-plan"
    }, {
      path: "serviceSystem/professionalGroup/scheme",
      component: _10a27cfc,
      name: "index-serviceSystem-professionalGroup-scheme"
    }, {
      path: "serviceSystem/professionNew/estimate-plan",
      component: _0a91a039,
      name: "index-serviceSystem-professionNew-estimate-plan"
    }, {
      path: "serviceSystem/professionNew/final-plan",
      component: _0685704b,
      name: "index-serviceSystem-professionNew-final-plan"
    }, {
      path: "serviceSystem/professionNew/initial-plan",
      component: _22b7fe86,
      name: "index-serviceSystem-professionNew-initial-plan"
    }, {
      path: "serviceSystem/professionNew/scheme",
      component: _6cafa690,
      name: "index-serviceSystem-professionNew-scheme"
    }, {
      path: "serviceSystem/volunteer/edit",
      component: _4a007728,
      name: "index-serviceSystem-volunteer-edit"
    }, {
      path: "serviceSystem/volunteer/view",
      component: _7a6c68f2,
      name: "index-serviceSystem-volunteer-view"
    }, {
      path: "serviceSystemArt/commonFile/designThought",
      component: _1f564821,
      name: "index-serviceSystemArt-commonFile-designThought"
    }, {
      path: "serviceSystemArt/commonFile/designThoughtForOp",
      component: _6cec7e19,
      name: "index-serviceSystemArt-commonFile-designThoughtForOp"
    }, {
      path: "serviceSystemArt/commonFile/hm",
      component: _3b22f562,
      name: "index-serviceSystemArt-commonFile-hm"
    }, {
      path: "serviceSystemArt/commonFile/hmDesignThoughtModal",
      component: _15bc4cbe,
      name: "index-serviceSystemArt-commonFile-hmDesignThoughtModal"
    }, {
      path: "serviceSystemArt/commonFile/hmLeaveMessageModal",
      component: _13572544,
      name: "index-serviceSystemArt-commonFile-hmLeaveMessageModal"
    }, {
      path: "serviceSystemArt/commonFile/hmPreview",
      component: _2cf11ba9,
      name: "index-serviceSystemArt-commonFile-hmPreview"
    }, {
      path: "serviceSystemArt/commonFile/hmScheme",
      component: _e2f9d158,
      name: "index-serviceSystemArt-commonFile-hmScheme"
    }, {
      path: "serviceSystemArt/commonFile/serviceStep",
      component: _be9d3d72,
      name: "index-serviceSystemArt-commonFile-serviceStep"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan",
      component: _40f87245,
      name: "index-serviceSystemArt-general-province-estimate-plan"
    }, {
      path: "serviceSystemArt/general-province/final-plan",
      component: _6f3a8c82,
      name: "index-serviceSystemArt-general-province-final-plan"
    }, {
      path: "serviceSystemArt/general-province/initial-plan",
      component: _a356859e,
      name: "index-serviceSystemArt-general-province-initial-plan"
    }, {
      path: "serviceSystemArt/general-province/scheme",
      component: _06186bf8,
      name: "index-serviceSystemArt-general-province-scheme"
    }, {
      path: "serviceSystemArt/general-province/smart-report",
      component: _511e2952,
      name: "index-serviceSystemArt-general-province-smart-report"
    }, {
      path: "serviceSystemArt/new-regulation/estimate-plan",
      component: _3869d478,
      name: "index-serviceSystemArt-new-regulation-estimate-plan"
    }, {
      path: "serviceSystemArt/new-regulation/final-plan",
      component: _fa6d820c,
      name: "index-serviceSystemArt-new-regulation-final-plan"
    }, {
      path: "serviceSystemArt/new-regulation/initial-plan",
      component: _fbd2ef28,
      name: "index-serviceSystemArt-new-regulation-initial-plan"
    }, {
      path: "serviceSystemArt/new-regulation/scheme",
      component: _e98b9402,
      name: "index-serviceSystemArt-new-regulation-scheme"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan",
      component: _5f93fe8f,
      name: "index-serviceSystemArt-new-version-estimate-plan"
    }, {
      path: "serviceSystemArt/new-version/final-plan",
      component: _3379a1b5,
      name: "index-serviceSystemArt-new-version-final-plan"
    }, {
      path: "serviceSystemArt/new-version/initial-plan",
      component: _a15d00b2,
      name: "index-serviceSystemArt-new-version-initial-plan"
    }, {
      path: "serviceSystemArt/new-version/scheme",
      component: _bd0dc60c,
      name: "index-serviceSystemArt-new-version-scheme"
    }, {
      path: "serviceSystemArt/new-version/smart-report",
      component: _4f24a466,
      name: "index-serviceSystemArt-new-version-smart-report"
    }, {
      path: "serviceSystemArt/occupations/occupation",
      component: _65c45d3a,
      name: "index-serviceSystemArt-occupations-occupation"
    }, {
      path: "serviceSystemArt/occupations/planning",
      component: _41f46c35,
      name: "index-serviceSystemArt-occupations-planning"
    }, {
      path: "serviceSystemArt/occupations/report",
      component: _2f8f948c,
      name: "index-serviceSystemArt-occupations-report"
    }, {
      path: "serviceSystemArt/occupations/scheme",
      component: _1d7f5bbd,
      name: "index-serviceSystemArt-occupations-scheme"
    }, {
      path: "serviceSystemArt/opportunities-plan-xk/scheme",
      component: _7a11e7ac,
      name: "index-serviceSystemArt-opportunities-plan-xk-scheme"
    }, {
      path: "serviceSystemArt/opportunities-plan/page",
      component: _308dee5b,
      name: "index-serviceSystemArt-opportunities-plan-page"
    }, {
      path: "serviceSystemArt/opportunities-plan/scheme",
      component: _679dd734,
      name: "index-serviceSystemArt-opportunities-plan-scheme"
    }, {
      path: "serviceSystemArt/serviceConditions/1",
      component: _aa384e9e,
      name: "index-serviceSystemArt-serviceConditions-1"
    }, {
      path: "aiReporting/appletProductShare/component/editDrawer",
      component: _1e9d7ca7,
      name: "index-aiReporting-appletProductShare-component-editDrawer"
    }, {
      path: "aiReporting/creditCards/componts/editDialog",
      component: _ad0be538,
      name: "index-aiReporting-creditCards-componts-editDialog"
    }, {
      path: "aiReporting/feedbackStatistics/componts/editDialog",
      component: _827ae4b0,
      name: "index-aiReporting-feedbackStatistics-componts-editDialog"
    }, {
      path: "aiReporting/gptfeedback/componts/editDialog",
      component: _2f407caa,
      name: "index-aiReporting-gptfeedback-componts-editDialog"
    }, {
      path: "aiReporting/headQuarters/components/addModal",
      component: _770ba778,
      name: "index-aiReporting-headQuarters-components-addModal"
    }, {
      path: "aiReporting/headQuarters/components/codeLibrary",
      component: _f2054e5c,
      name: "index-aiReporting-headQuarters-components-codeLibrary"
    }, {
      path: "aiReporting/headQuarters/components/vipCard",
      component: _6220be11,
      name: "index-aiReporting-headQuarters-components-vipCard"
    }, {
      path: "aiReporting/redemptionCode/components/addModal",
      component: _ea9a0dae,
      name: "index-aiReporting-redemptionCode-components-addModal"
    }, {
      path: "aiReporting/redemptionCode/components/codeLibrary",
      component: _b9ce44fe,
      name: "index-aiReporting-redemptionCode-components-codeLibrary"
    }, {
      path: "aiReporting/redemptionCode/components/vipModal",
      component: _efa355a6,
      name: "index-aiReporting-redemptionCode-components-vipModal"
    }, {
      path: "aiReporting/timeAxis/components/timeDrawer",
      component: _33e8c2de,
      name: "index-aiReporting-timeAxis-components-timeDrawer"
    }, {
      path: "artExamination/academic/components/add",
      component: _50327a81,
      name: "index-artExamination-academic-components-add"
    }, {
      path: "artExamination/onePointOneLevelArt/components/edit",
      component: _77227440,
      name: "index-artExamination-onePointOneLevelArt-components-edit"
    }, {
      path: "artExamination/policy/components/add",
      component: _aee3a294,
      name: "index-artExamination-policy-components-add"
    }, {
      path: "company/courselearning/components/editCategory",
      component: _0cd4444f,
      name: "index-company-courselearning-components-editCategory"
    }, {
      path: "company/CourseLearningProgress/components/table-expand",
      component: _c6bd17a6,
      name: "index-company-CourseLearningProgress-components-table-expand"
    }, {
      path: "comprehensive/application/components/add",
      component: _18edc134,
      name: "index-comprehensive-application-components-add"
    }, {
      path: "comprehensive/coverLetter/components/add",
      component: _0d45eea7,
      name: "index-comprehensive-coverLetter-components-add"
    }, {
      path: "comprehensive/matchIntroduce/components/add",
      component: _68b88aa0,
      name: "index-comprehensive-matchIntroduce-components-add"
    }, {
      path: "comprehensive/qualitySpecialityInfo/components/add",
      component: _fe2eb6fc,
      name: "index-comprehensive-qualitySpecialityInfo-components-add"
    }, {
      path: "comprehensive/universityManage/components/add",
      component: _e5c8aaf2,
      name: "index-comprehensive-universityManage-components-add"
    }, {
      path: "comprehensive/videoManagement/components/add",
      component: _238c2a26,
      name: "index-comprehensive-videoManagement-components-add"
    }, {
      path: "comprehensive/videoManagement/components/player",
      component: _408d37a3,
      name: "index-comprehensive-videoManagement-components-player"
    }, {
      path: "comprehensive/videoManagement/components/videoList",
      component: _0ad0e37e,
      name: "index-comprehensive-videoManagement-components-videoList"
    }, {
      path: "generalService/disciplineCategoryManagement/components/updateDrawer",
      component: _2a3e7cd6,
      name: "index-generalService-disciplineCategoryManagement-components-updateDrawer"
    }, {
      path: "hmtservice/interviwe/materials/addMaterial",
      component: _5017219c,
      name: "index-hmtservice-interviwe-materials-addMaterial"
    }, {
      path: "hmtservice/interviwe/video/videoDrawer",
      component: _84484462,
      name: "index-hmtservice-interviwe-video-videoDrawer"
    }, {
      path: "information/newsList/components/newsDetail",
      component: _92801a98,
      name: "index-information-newsList-components-newsDetail"
    }, {
      path: "information/newsList/components/push",
      component: _3b0973ca,
      name: "index-information-newsList-components-push"
    }, {
      path: "information/speciality/components/detail",
      component: _37055ef6,
      name: "index-information-speciality-components-detail"
    }, {
      path: "information/speciality/components/push",
      component: _6ae431ce,
      name: "index-information-speciality-components-push"
    }, {
      path: "myToolBox/answers/components/editClassify",
      component: _1af7937a,
      name: "index-myToolBox-answers-components-editClassify"
    }, {
      path: "myToolBox/answers/components/editDescribe",
      component: _6109970a,
      name: "index-myToolBox-answers-components-editDescribe"
    }, {
      path: "myToolBox/answers/components/feedback",
      component: _18e3621a,
      name: "index-myToolBox-answers-components-feedback"
    }, {
      path: "myToolBox/libraryManage/components/editCategory",
      component: _b525d770,
      name: "index-myToolBox-libraryManage-components-editCategory"
    }, {
      path: "myToolBox/libraryManage/components/editLibrary",
      component: _2a6f6fe1,
      name: "index-myToolBox-libraryManage-components-editLibrary"
    }, {
      path: "notice/components/stationNotification/myReceived",
      component: _0099ff98,
      name: "index-notice-components-stationNotification-myReceived"
    }, {
      path: "notice/components/stationNotification/myRelease",
      component: _0417a22c,
      name: "index-notice-components-stationNotification-myRelease"
    }, {
      path: "padManage/inventory/components/balance",
      component: _7e06bfc2,
      name: "index-padManage-inventory-components-balance"
    }, {
      path: "padManage/inventory/components/detail",
      component: _5e002c5e,
      name: "index-padManage-inventory-components-detail"
    }, {
      path: "selfService/components/stepThree/recruitmentModel",
      component: _02a40b1b,
      name: "index-selfService-components-stepThree-recruitmentModel"
    }, {
      path: "selfService/components/stepTwo/excellentList",
      component: _6b552bb8,
      name: "index-selfService-components-stepTwo-excellentList"
    }, {
      path: "selfService/components/stepTwo/excellentModel",
      component: _54162913,
      name: "index-selfService-components-stepTwo-excellentModel"
    }, {
      path: "selfService/components/stepTwo/passwayList",
      component: _3807c92c,
      name: "index-selfService-components-stepTwo-passwayList"
    }, {
      path: "selfService/components/stepTwo/passwayModel",
      component: _c6a0a9ea,
      name: "index-selfService-components-stepTwo-passwayModel"
    }, {
      path: "selfService/components/stepTwo/seniorityList",
      component: _73f54328,
      name: "index-selfService-components-stepTwo-seniorityList"
    }, {
      path: "selfService/stepFive/components/DesignThoughtModal",
      component: _c834cd5c,
      name: "index-selfService-stepFive-components-DesignThoughtModal"
    }, {
      path: "selfService/stepFive/components/LeaveMessageModal",
      component: _299d18e6,
      name: "index-selfService-stepFive-components-LeaveMessageModal"
    }, {
      path: "selfService/stepFive/components/recruitmentModel",
      component: _14ba4fad,
      name: "index-selfService-stepFive-components-recruitmentModel"
    }, {
      path: "selfService/stepFive/components/studentInfo",
      component: _7f61c5f9,
      name: "index-selfService-stepFive-components-studentInfo"
    }, {
      path: "serviceSystem/general-province/components/downloadPDF",
      component: _45b44904,
      name: "index-serviceSystem-general-province-components-downloadPDF"
    }, {
      path: "serviceSystem/general-province/components/downloadPDFNew",
      component: _8f68ed1c,
      name: "index-serviceSystem-general-province-components-downloadPDFNew"
    }, {
      path: "serviceSystem/general-province/components/leave-message",
      component: _1ec876b6,
      name: "index-serviceSystem-general-province-components-leave-message"
    }, {
      path: "serviceSystem/general-province/components/newPlan-by-lastStep",
      component: _5f06bb88,
      name: "index-serviceSystem-general-province-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystem/general-province/components/scheme-inspect",
      component: _c20f2330,
      name: "index-serviceSystem-general-province-components-scheme-inspect"
    }, {
      path: "serviceSystem/general-province/components/studentInfo",
      component: _5529ab86,
      name: "index-serviceSystem-general-province-components-studentInfo"
    }, {
      path: "serviceSystem/general-province/components/visable-field-config",
      component: _d6ff8738,
      name: "index-serviceSystem-general-province-components-visable-field-config"
    }, {
      path: "serviceSystem/general-province/utils/utils",
      component: _55562b4e,
      name: "index-serviceSystem-general-province-utils-utils"
    }, {
      path: "serviceSystem/new-version/components/design-thought",
      component: _fde3215c,
      name: "index-serviceSystem-new-version-components-design-thought"
    }, {
      path: "serviceSystem/new-version/components/leave-message",
      component: _f997f34e,
      name: "index-serviceSystem-new-version-components-leave-message"
    }, {
      path: "serviceSystem/new-version/components/newPlan-by-lastStep",
      component: _468be63c,
      name: "index-serviceSystem-new-version-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystem/new-version/components/scheme-inspect",
      component: _5f686334,
      name: "index-serviceSystem-new-version-components-scheme-inspect"
    }, {
      path: "serviceSystem/new-version/components/studentInfo",
      component: _a65f6e1e,
      name: "index-serviceSystem-new-version-components-studentInfo"
    }, {
      path: "serviceSystem/new-version/components/visable-field-config",
      component: _c4bf2fa0,
      name: "index-serviceSystem-new-version-components-visable-field-config"
    }, {
      path: "serviceSystem/new-version/utils/utils",
      component: _9be911e6,
      name: "index-serviceSystem-new-version-utils-utils"
    }, {
      path: "serviceSystem/newRegulation/downloadPDF/downloadPDF",
      component: _53b0891a,
      name: "index-serviceSystem-newRegulation-downloadPDF-downloadPDF"
    }, {
      path: "serviceSystem/opportunities-plan/components/leave-message",
      component: _5bf6ccd6,
      name: "index-serviceSystem-opportunities-plan-components-leave-message"
    }, {
      path: "serviceSystem/opportunities-plan/components/scheme-preview",
      component: _0e7281a8,
      name: "index-serviceSystem-opportunities-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/opportunities-plan/components/studentInfo",
      component: _6fe47b2d,
      name: "index-serviceSystem-opportunities-plan-components-studentInfo"
    }, {
      path: "serviceSystem/professionalGroup/components/chooseSpeciality",
      component: _355206c1,
      name: "index-serviceSystem-professionalGroup-components-chooseSpeciality"
    }, {
      path: "serviceSystem/professionalGroup/components/fieldConfig",
      component: _eb52b812,
      name: "index-serviceSystem-professionalGroup-components-fieldConfig"
    }, {
      path: "serviceSystem/professionalGroup/components/newPlanByLastStep",
      component: _1f17079d,
      name: "index-serviceSystem-professionalGroup-components-newPlanByLastStep"
    }, {
      path: "serviceSystem/professionalGroup/components/preview",
      component: _5e9cfe63,
      name: "index-serviceSystem-professionalGroup-components-preview"
    }, {
      path: "serviceSystem/professionalGroup/utils/utils",
      component: _121280c0,
      name: "index-serviceSystem-professionalGroup-utils-utils"
    }, {
      path: "serviceSystem/professionNew/components/newPlanByLastStep",
      component: _d032ed9e,
      name: "index-serviceSystem-professionNew-components-newPlanByLastStep"
    }, {
      path: "serviceSystem/professionNew/components/preview",
      component: _3181a8f7,
      name: "index-serviceSystem-professionNew-components-preview"
    }, {
      path: "serviceSystem/professionNew/utils/utils",
      component: _50c4ff54,
      name: "index-serviceSystem-professionNew-utils-utils"
    }, {
      path: "serviceSystem/serviceConditions/components/addConfig",
      component: _32ba8e89,
      name: "index-serviceSystem-serviceConditions-components-addConfig"
    }, {
      path: "serviceSystemArt/general-province/components/downloadPDF",
      component: _e2369b26,
      name: "index-serviceSystemArt-general-province-components-downloadPDF"
    }, {
      path: "serviceSystemArt/general-province/components/leave-message",
      component: _2e009bd4,
      name: "index-serviceSystemArt-general-province-components-leave-message"
    }, {
      path: "serviceSystemArt/general-province/components/newPlan-by-lastStep",
      component: _13733377,
      name: "index-serviceSystemArt-general-province-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystemArt/general-province/components/scheme-inspect",
      component: _0e2e7d19,
      name: "index-serviceSystemArt-general-province-components-scheme-inspect"
    }, {
      path: "serviceSystemArt/general-province/components/studentInfo",
      component: _f1abfda8,
      name: "index-serviceSystemArt-general-province-components-studentInfo"
    }, {
      path: "serviceSystemArt/general-province/components/visable-field-config",
      component: _6da2c255,
      name: "index-serviceSystemArt-general-province-components-visable-field-config"
    }, {
      path: "serviceSystemArt/general-province/utils/utils",
      component: _22392070,
      name: "index-serviceSystemArt-general-province-utils-utils"
    }, {
      path: "serviceSystemArt/new-regulation/components/SmartReport",
      component: _292470c4,
      name: "index-serviceSystemArt-new-regulation-components-SmartReport"
    }, {
      path: "serviceSystemArt/new-regulation/downloadPDF/downloadPDF",
      component: _9ab3efca,
      name: "index-serviceSystemArt-new-regulation-downloadPDF-downloadPDF"
    }, {
      path: "serviceSystemArt/new-version/components/design-thought",
      component: _3db793fe,
      name: "index-serviceSystemArt-new-version-components-design-thought"
    }, {
      path: "serviceSystemArt/new-version/components/leave-message",
      component: _5d032dca,
      name: "index-serviceSystemArt-new-version-components-leave-message"
    }, {
      path: "serviceSystemArt/new-version/components/newPlan-by-lastStep",
      component: _947c1626,
      name: "index-serviceSystemArt-new-version-components-newPlan-by-lastStep"
    }, {
      path: "serviceSystemArt/new-version/components/scheme-inspect",
      component: _8103ac3a,
      name: "index-serviceSystemArt-new-version-components-scheme-inspect"
    }, {
      path: "serviceSystemArt/new-version/components/studentInfo",
      component: _5e7498a2,
      name: "index-serviceSystemArt-new-version-components-studentInfo"
    }, {
      path: "serviceSystemArt/new-version/components/visable-field-config",
      component: _152c2f9f,
      name: "index-serviceSystemArt-new-version-components-visable-field-config"
    }, {
      path: "serviceSystemArt/new-version/utils/utils",
      component: _e125ef84,
      name: "index-serviceSystemArt-new-version-utils-utils"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/leave-message",
      component: _49906104,
      name: "index-serviceSystemArt-opportunities-plan-components-leave-message"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/scheme-preview",
      component: _72b3e59d,
      name: "index-serviceSystemArt-opportunities-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/opportunities-plan/components/studentInfo",
      component: _a56d5b48,
      name: "index-serviceSystemArt-opportunities-plan-components-studentInfo"
    }, {
      path: "stationNotification/myReceived/components/edit",
      component: _ceccb8ba,
      name: "index-stationNotification-myReceived-components-edit"
    }, {
      path: "stationNotification/myReceived/components/readView",
      component: _29a589f4,
      name: "index-stationNotification-myReceived-components-readView"
    }, {
      path: "stationNotification/myRelease/components/edit",
      component: _447b035d,
      name: "index-stationNotification-myRelease-components-edit"
    }, {
      path: "IPADManage/agentManage/agentCardManage/components/soldRecords",
      component: _b7a36fe6,
      name: "index-IPADManage-agentManage-agentCardManage-components-soldRecords"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/customerDetail",
      component: _587151e9,
      name: "index-IPADManage-agentManage-agentCustomer-components-customerDetail"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/orderList",
      component: _2c340f62,
      name: "index-IPADManage-agentManage-agentCustomer-components-orderList"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/province",
      component: _7bdc4605,
      name: "index-IPADManage-agentManage-agentCustomer-components-province"
    }, {
      path: "IPADManage/agentManage/agentCustomer/components/viewInfo",
      component: _04b81c8d,
      name: "index-IPADManage-agentManage-agentCustomer-components-viewInfo"
    }, {
      path: "IPADManage/agentManage/agentList/components/hairpin",
      component: _5e8bef09,
      name: "index-IPADManage-agentManage-agentList-components-hairpin"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/card-list",
      component: _6776adeb,
      name: "index-IPADManage-agentManage-agentProfit-components-card-list"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/dictConfig",
      component: _060a87f7,
      name: "index-IPADManage-agentManage-agentProfit-components-dictConfig"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/orderDetail",
      component: _1af21def,
      name: "index-IPADManage-agentManage-agentProfit-components-orderDetail"
    }, {
      path: "IPADManage/agentManage/agentProfit/components/orderList",
      component: _3b0a1d88,
      name: "index-IPADManage-agentManage-agentProfit-components-orderList"
    }, {
      path: "IPADManage/agentManage/agentProfit2/components/witchdraw",
      component: _eaaa7176,
      name: "index-IPADManage-agentManage-agentProfit2-components-witchdraw"
    }, {
      path: "IPADManage/agentManage/agentProfit2/components/witchdrawOrder",
      component: _cbce5b8e,
      name: "index-IPADManage-agentManage-agentProfit2-components-witchdrawOrder"
    }, {
      path: "IPADManage/agentManage/cardUsageRecord/components/editTime",
      component: _acceb520,
      name: "index-IPADManage-agentManage-cardUsageRecord-components-editTime"
    }, {
      path: "IPADManage/agentManage/revenueBreakdownQuery/components/table-expand",
      component: _74616073,
      name: "index-IPADManage-agentManage-revenueBreakdownQuery-components-table-expand"
    }, {
      path: "IPADManage/agentManage/searchCard/components/cardView",
      component: _ed25c00c,
      name: "index-IPADManage-agentManage-searchCard-components-cardView"
    }, {
      path: "IPADManage/agentManage/searchCard/components/convertCard",
      component: _04d32f4e,
      name: "index-IPADManage-agentManage-searchCard-components-convertCard"
    }, {
      path: "IPADManage/agentManage/searchCard/components/invalidCard",
      component: _48047f92,
      name: "index-IPADManage-agentManage-searchCard-components-invalidCard"
    }, {
      path: "noticeOnline/components/myReceived/components/edit",
      component: _f24319b0,
      name: "index-noticeOnline-components-myReceived-components-edit"
    }, {
      path: "noticeOnline/components/mySend/components/edit",
      component: _4cb1b662,
      name: "index-noticeOnline-components-mySend-components-edit"
    }, {
      path: "noticeOnline/components/mySend/components/readView",
      component: _38769520,
      name: "index-noticeOnline-components-mySend-components-readView"
    }, {
      path: "serviceSystem/general-province/estimate-plan/components/choose-of-profession",
      component: _7b24c6d7,
      name: "index-serviceSystem-general-province-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/estimate-plan/components/scheme-preview",
      component: _247c353b,
      name: "index-serviceSystem-general-province-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/final-plan/components/choose-of-profession",
      component: _7a13e6da,
      name: "index-serviceSystem-general-province-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/final-plan/components/scheme-preview",
      component: _45991012,
      name: "index-serviceSystem-general-province-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/initial-plan/components/choose-of-profession",
      component: _54d06545,
      name: "index-serviceSystem-general-province-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/initial-plan/components/scheme-preview",
      component: _1522be29,
      name: "index-serviceSystem-general-province-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/general-province/smart-report/components/choose-of-profession",
      component: _25f78feb,
      name: "index-serviceSystem-general-province-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystem/general-province/smart-report/components/scheme-detail",
      component: _45fc94cc,
      name: "index-serviceSystem-general-province-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/choose-of-profession",
      component: _fc1344ba,
      name: "index-serviceSystem-new-version-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/downloadPDF",
      component: _4c5f471a,
      name: "index-serviceSystem-new-version-estimate-plan-components-downloadPDF"
    }, {
      path: "serviceSystem/new-version/estimate-plan/components/scheme-preview",
      component: _9a6c55f2,
      name: "index-serviceSystem-new-version-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/final-plan/components/choose-of-profession",
      component: _83a66d72,
      name: "index-serviceSystem-new-version-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/final-plan/components/scheme-preview",
      component: _4492cbab,
      name: "index-serviceSystem-new-version-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/initial-plan/components/choose-of-profession",
      component: _5d4ac4f9,
      name: "index-serviceSystem-new-version-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/initial-plan/components/scheme-preview",
      component: _21fbf4dd,
      name: "index-serviceSystem-new-version-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystem/new-version/smart-report/components/choose-of-profession",
      component: _2e71ef9f,
      name: "index-serviceSystem-new-version-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystem/new-version/smart-report/components/scheme-detail",
      component: _618cd866,
      name: "index-serviceSystem-new-version-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan/components/choose-of-profession",
      component: _46899308,
      name: "index-serviceSystemArt-general-province-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/estimate-plan/components/scheme-preview",
      component: _44938ba8,
      name: "index-serviceSystemArt-general-province-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/final-plan/components/choose-of-profession",
      component: _6c89d3fc,
      name: "index-serviceSystemArt-general-province-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/final-plan/components/scheme-preview",
      component: _0dc7feb4,
      name: "index-serviceSystemArt-general-province-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/initial-plan/components/choose-of-profession",
      component: _830e6218,
      name: "index-serviceSystemArt-general-province-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/initial-plan/components/scheme-preview",
      component: _4de851d0,
      name: "index-serviceSystemArt-general-province-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/general-province/smart-report/components/choose-of-profession",
      component: _e0c00ccc,
      name: "index-serviceSystemArt-general-province-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/general-province/smart-report/components/scheme-detail",
      component: _3e2a42cb,
      name: "index-serviceSystemArt-general-province-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/choose-of-profession",
      component: _2006125c,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/downloadPDF",
      component: _9a1a3b38,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-downloadPDF"
    }, {
      path: "serviceSystemArt/new-version/estimate-plan/components/scheme-preview",
      component: _296a8514,
      name: "index-serviceSystemArt-new-version-estimate-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/final-plan/components/choose-of-profession",
      component: _1f555678,
      name: "index-serviceSystemArt-new-version-final-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/final-plan/components/scheme-preview",
      component: _1db5519c,
      name: "index-serviceSystemArt-new-version-final-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/initial-plan/components/choose-of-profession",
      component: _1684c9ea,
      name: "index-serviceSystemArt-new-version-initial-plan-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/initial-plan/components/scheme-preview",
      component: _3c94c28e,
      name: "index-serviceSystemArt-new-version-initial-plan-components-scheme-preview"
    }, {
      path: "serviceSystemArt/new-version/smart-report/components/choose-of-profession",
      component: _30a816e0,
      name: "index-serviceSystemArt-new-version-smart-report-components-choose-of-profession"
    }, {
      path: "serviceSystemArt/new-version/smart-report/components/scheme-detail",
      component: _a689ded6,
      name: "index-serviceSystemArt-new-version-smart-report-components-scheme-detail"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/general-province/initial-plan",
      component: _7bb518fb,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-general-province-initial-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/general-province/scheme-preview",
      component: _7de85949,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-general-province-scheme-preview"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/initial-plan",
      component: _759adf79,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-initial-plan"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/PlanSelection",
      component: _192dfd28,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-PlanSelection"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-regulation/RightDrawer",
      component: _3d371b14,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-regulation-RightDrawer"
    }, {
      path: "serviceSystemArt/opportunities-plan/initial-plan/new-version/initial-plan",
      component: _449f1f92,
      name: "index-serviceSystemArt-opportunities-plan-initial-plan-new-version-initial-plan"
    }, {
      path: "notice/components/stationNotification/myReceived/components/edit",
      component: _44c5abc5,
      name: "index-notice-components-stationNotification-myReceived-components-edit"
    }, {
      path: "notice/components/stationNotification/myRelease/components/edit",
      component: _187c6efb,
      name: "index-notice-components-stationNotification-myRelease-components-edit"
    }, {
      path: "notice/components/stationNotification/myRelease/components/readView",
      component: _1a02e94c,
      name: "index-notice-components-stationNotification-myRelease-components-readView"
    }]
  }, {
    path: "/policy",
    component: _27e0c2f6,
    name: "policy"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
